import "./style.css";
import React from 'react';
import Layout from "../../layout/Layout";
import trash_icon from "../../../icons/dashboard/trash-icon.svg";
import AdminInput from "../components/AdminInput";
import AdminModal from "../components/AdminModal";
import ConfirmationModal from "../components/ConfirmationModal";
import AdminTextArea from "../components/AdminTextArea";
import { useState, useEffect } from "react";
import {
  fetchClients,
  getDetails,
  formatTravelDate,
  getBookingType,
  deleteTransfer,
  activeQuotation,
  addUser,
  duplicateBooking,
  addQuotationItems,
  removeAllItems,
  addStandaloneItems,
  removeStandaloneItems,
  createAndActivateQuotation,
  chargeQuotation,
  reactivateQuotation,
  expireQuotation,
  saveBookingSortOrder,
} from "../../../actions/admin/quotation";
import AddClientModal from "./_components/modals/AddClientModal";
import EditClientModal from "./_components/modals/EditClientModal";
import { useParams, useHistory, useLocation } from "react-router-dom";
import AdminInputDatePicker from "../components/AdminInputDatePicker";
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
  getAdditionalGroups,
  getAllAdditionalItems,
  computeQuotationTotalAmount,
  computeStandaloneItemsTotal,
} from "./_utils/quotationTotals";
import { BsPlusCircle, BsX } from "react-icons/bs";
import {
  EditPenIcon,
  BackAltIcon,
  AddAltIcon,
  DownloadAltIcon,
  ArrowOutwardIcon,
  CalendarAltIcon,
  EyeGoldIcon,
  EditIcon,
  CopyIcon,
  UserIcon,
  SelectArrowIcon,
} from "../../icons/index"
import RemoveAllItemsConfirmationModal from "./_components/modals/RemoveAllItemsConfirmationModal";
import ErrorModal from "./_components/modals/ErrorModal";
import SubmitConfirmationModal from "./_components/modals/SubmitConfirmationModal";
import DeleteTransferConfirmationModal from "./_components/modals/DeleteTransferConfirmationModal";
import TransferDetailModal from "./_components/modals/TransferDetailModal";
import DuplicateTransferModal from "./_components/modals/DuplicateTransferModal";
import ActivateQuotationModal from "./_components/modals/ActivateQuotationModal";
import ChargeFailedNotice from "./_components/ChargeFailedNotice";
import { BOOKING_SORT_ORDER, orderBookingsByIds } from "./_utils/sortQuotationBookings";

// The buttons shown above the Transfer List to change the order of the transfers.
const BOOKING_SORT_OPTIONS = [
  { value: BOOKING_SORT_ORDER.TRAVEL_DATE, label: "Travel Date" },
  { value: BOOKING_SORT_ORDER.ADDED_AT, label: "Added At" },
];

// "travelDate" -> "Travel Date", used in the confirmation popup title.
const getBookingSortLabel = (sortOrder) =>
  BOOKING_SORT_OPTIONS.find((option) => option.value === sortOrder)?.label || "";

const check_green ="https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/check_green.svg";

const QuotationDetailSkeleton = () => (
  <div id="body">
    {/* Billing Information */}
    <div className="accordion mb-4">
      <div className="accordion-item">
        <div className="accordion-button with-arrow-2 bg-white py-3">
          <div className="tw:h-4 tw:w-40 tw:animate-pulse tw:bg-gray-200 tw:rounded" />
        </div>
        <div className="p-3">
          <div className="row g-3">
            <div className="col-md-6">
              <div className="tw:h-3 tw:w-6 tw:animate-pulse tw:bg-gray-200 tw:rounded tw:mb-3" />
              <div className="tw:h-10 tw:w-full tw:animate-pulse tw:bg-gray-200 tw:rounded" />
            </div>
            <div className="col-md-6">
              <div className="tw:h-3 tw:w-10 tw:animate-pulse tw:bg-gray-200 tw:rounded tw:mb-3" />
              <div className="tw:h-28 tw:w-full tw:animate-pulse tw:bg-gray-200 tw:rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Quotation Information */}
    <div className="accordion mb-4">
      <div className="accordion-item">
        <div className="accordion-button with-arrow-2 bg-white py-3 px-3">
          <div className="tw:h-4 tw:w-48 tw:animate-pulse tw:bg-gray-200 tw:rounded" />
        </div>
        <div className="p-3">
          <div className="row g-3">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="col-md-3">
                <div className="tw:h-3 tw:w-24 tw:animate-pulse tw:bg-gray-200 tw:rounded tw:mb-2" />
                <div className="tw:h-10 tw:w-full tw:animate-pulse tw:bg-gray-200 tw:rounded" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

    {/* Transfer List */}
    <div className="accordion mb-4">
      <div className="accordion-item">
        <div className="accordion-button with-arrow-2 bg-white py-3 px-3">
          <div className="tw:h-4 tw:w-28 tw:animate-pulse tw:bg-gray-200 tw:rounded" />
        </div>
        <div className="p-3">
          {[1, 2].map((i) => (
            <div key={i} className="border rounded p-3 mb-2">
              <div className="row g-2">
                {[1, 2, 3, 4].map((j) => (
                  <div key={j} className="col-md-2">
                    <div className="tw:h-3 tw:w-16 tw:animate-pulse tw:bg-gray-200 tw:rounded tw:mb-2" />
                    <div className="tw:h-4 tw:w-24 tw:animate-pulse tw:bg-gray-200 tw:rounded" />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Quotation Items */}
    <div className="accordion mb-4">
      <div className="accordion-item">
        <div className="accordion-button with-arrow-2 bg-white py-3 px-3">
          <div className="tw:h-4 tw:w-36 tw:animate-pulse tw:bg-gray-200 tw:rounded" />
        </div>
        <div>
          <div className="tw:h-10 tw:bg-gray-800" />
          {[1, 2, 3].map((i) => (
            <div key={i} className="d-flex gap-3 p-3 border-bottom">
              <div className="tw:h-4 tw:w-[14%] tw:animate-pulse tw:bg-gray-200 tw:rounded" />
              <div className="tw:h-4 tw:flex-1 tw:animate-pulse tw:bg-gray-200 tw:rounded" />
              <div className="tw:h-4 tw:w-[12%] tw:animate-pulse tw:bg-gray-200 tw:rounded" />
              <div className="tw:h-4 tw:w-[5%] tw:animate-pulse tw:bg-gray-200 tw:rounded" />
              <div className="tw:h-4 tw:w-[12%] tw:animate-pulse tw:bg-gray-200 tw:rounded" />
            </div>
          ))}
          <div className="tw:h-10 tw:bg-gray-800" />
        </div>
      </div>
    </div>

    {/* Notes */}
    <div className="accordion mb-4">
      <div className="accordion-item">
        <div className="accordion-button with-arrow-2 bg-white py-3 px-3">
          <div className="tw:h-4 tw:w-16 tw:animate-pulse tw:bg-gray-200 tw:rounded" />
        </div>
        <div className="p-3">
          <div className="tw:h-24 tw:w-full tw:animate-pulse tw:bg-gray-200 tw:rounded" />
        </div>
      </div>
    </div>
  </div>
);

const QuotationDetail = () => {
  const { t } = useTranslation();
  const [errorText, setErrorText] = useState("");
  const history = useHistory();
  const location = useLocation();
  // Set when navigating back here from the transfer page so the in-progress
  // draft (client, quotation info, notes, standalone items) is preserved
  // instead of being wiped as if starting a brand-new quotation.
  const keepDraft = location.state?.keepDraft === true;
  var { quotationId } = useParams();

  const [quotationDetail, setQuotationDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [notes, setNotes] = useState("");
  // Local-only standalone (non-booking) item groups held in state before the
  // quotation is saved (no quotationId yet). Declared early so the persistence
  // effects below can reference it without hitting a temporal-dead-zone error.
  const [localStandaloneGroups, setLocalStandaloneGroups] = useState([]);
  const [showDiscounted, setShowDiscounted] = useState(false);
  // Global rate used by the "Apply to all" convenience control.
  const [discount, setDiscount] = useState(0);
  const [isDiscountApplied, setIsDiscountApplied] = useState(false);
  // Per-transfer discount rates keyed by booking id: { [bookingId]: rate }.
  // A booking is discounted when its rate is > 0.
  const [bookingDiscounts, setBookingDiscounts] = useState({});
  // How the transfers are ordered (saved on the quotation): by travel date or by when they were added.
  const [bookingSortOrder, setBookingSortOrder] = useState(BOOKING_SORT_ORDER.ADDED_AT);
  // The order the admin clicked but has not confirmed yet. While it is set, the
  // confirmation popup is open.
  const [pendingBookingSortOrder, setPendingBookingSortOrder] = useState(null);
  const [isSavingSortOrder, setIsSavingSortOrder] = useState(false);
  const [sortOrderError, setSortOrderError] = useState("");

  const bookingItemsDetailOrder = [
    "charterCost",
    "lateNightFee",
    "discount",
    "tollFee",
    "longDistanceSurcharge",
    "driverAccomodationTotal"
  ]

  const bookingItemsDetailLabelMap = {
    charterCost: "Charter Cost",
    lateNightFee: "Late Night Fee",
    discount: "Discount",
    tollFee: "Toll Fee",
    longDistanceSurcharge: "Long Distance Surcharge",
    driverAccomodationTotal: "Driver Accommodation",
  };

  const getAdditionalItemBreakdown = (additionalItem) => {
    if (Array.isArray(additionalItem?.details) && additionalItem.details.length > 0) {
      return bookingItemsDetailOrder
        .filter((detailId) => detailId !== "discount")
        .map((detailId) => {
          const detail = additionalItem.details.find((item) => item.id === detailId);
          const amount = Number(detail?.amount || 0);

          if (amount <= 0) return null;

          return {
            id: detailId,
            name: detail?.name || bookingItemsDetailLabelMap[detailId] || detailId,
            amount,
          };
        })
        .filter(Boolean);
    }

    return bookingItemsDetailOrder
      .filter((detailId) => detailId !== "discount")
      .map((detailId) => {
        const amount = Number(additionalItem?.[detailId] || 0);

        if (amount <= 0) return null;

        return {
          id: detailId,
          name: bookingItemsDetailLabelMap[detailId] || detailId,
          amount,
        };
      })
      .filter(Boolean);
  };

  const handleNotes = (value) => {
    setNotes(value);
  };

  useEffect(() => {
    if (quotationId) {
      handleGetQuotationDetails(quotationId);
    } else if (!keepDraft) {
      // Only clear the draft on a genuine fresh start (e.g. from the list page).
      // When returning from the transfer page (keepDraft) we keep the draft.
      localStorage.removeItem("quotationData");
    }

    if (localStorage.getItem("editTransferData")) {
      localStorage.removeItem("editTransferData");
    }
  }, []);

  const handleGetQuotationDetails = async (quotationId) => {
    try {
      setIsLoading(true);
      var res = await getDetails(quotationId);
      // The backend already returns the bookings in the saved order.
      setQuotationDetail(res);
      setBookingSortOrder(res?.bookingSortOrder || BOOKING_SORT_ORDER.ADDED_AT);
      if (res.user) {
        var selectedClient = res.user;
        var quotationInformation = {
          quotationId: res.quotationID,
          bookingReference: res.quotationNumber,
          issueDate: moment(res.issueDate).format("YYYY-MM-DD"),
          validUntil: moment(res.expiredDate).format("YYYY-MM-DD"),
        };
        var notes = res.notes ?? "";

        const dataToSave = {
          quotationInformation,
          quotationId,
          selectedClient,
          notes,
        };
        localStorage.setItem("quotationData", JSON.stringify(dataToSave));

        setQuotationInformation(quotationInformation);
        setFromBillingInformationForm({
          selectedClient: selectedClient,
          clientInputText: selectedClient?.name,
        });
        setNotes(notes);
        if (res.useDiscount) {
          setShowDiscounted(true);
          setDiscount(res.discount);
          setIsDiscountApplied(true);
          // Restore each transfer's own discount rate.
          const restoredDiscounts = {};
          (res.bookings || []).forEach((booking) => {
            if (booking?.useDiscount && Number(booking?.discount) > 0) {
              restoredDiscounts[String(booking._id)] = Number(booking.discount);
            }
          });
          setBookingDiscounts(restoredDiscounts);
        }
      }
    } catch (error) {
      console.error("Error fetching quotation details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const [clients, setClients] = useState([]);

  const [loadingFetchClients, setLoadingFetchClients] = useState(false);

  const [fromBillingInformationForm, setFromBillingInformationForm] = useState({
    selectedClient: null,
    clientInputText: "",
  });

  const getClients = async (query) => {
    setLoadingFetchClients(true);
    try {
      const response = await fetchClients(query);
      if (response?.data.data) {
        setClients(response?.data.data.data);
      }
    } catch (error) {
      console.error("Error in getClients:", error);
    } finally {
      setLoadingFetchClients(false);
    }
  };

  useEffect(() => {
    getClients("");
  }, []);

  const handleSelectClient = (client) => {
    setFromBillingInformationForm({
      clientInputText: client.name,
      selectedClient: client,
    });
  };

  const handleSearchClient = (e) => {
    setFromBillingInformationForm({
      selectedClient: null,
      clientInputText: e.target.value,
    });
    getClients(e.target.value);
  };

  const getPhoneNumber = (item) => {
    if (item.role === "individual" || item.role === "business") {
      const accountDetail = item[item.role === "individual" ? "individualDetail" : "businessDetail"];
      const phone = accountDetail?.billingInformation?.phone;
      if (!phone) return "-";
      const rawPrefix = accountDetail?.billingInformation?.prefix_number ?? "-";
      const prefix = rawPrefix.replace(/[()]/g, "").trim();
      return `(${prefix}) ${phone}`;
    }
    return "";
  };

  const [quotationInformation, setQuotationInformation] = useState({
    quotationId: "",
    bookingReference: "",
    issueDate: moment().format("YYYY-MM-DD"),
    validUntil: moment().format("YYYY-MM-DD"),
  });

  const handleQuotationInformationChange = (e) =>
    setQuotationInformation({
      ...quotationInformation,
      [e.target.name]: e.target.value,
    });

  const handleIssueDateQuotationInformationChange = (date) => {
    const formattedDate = moment(date).format("YYYY-MM-DD");
    setQuotationInformation({
      ...quotationInformation,
      issueDate: formattedDate,
    });
  };
  const handleValidUntilQuotationInformationChange = (date) => {
    const formattedDate = moment(date).format("YYYY-MM-DD");
    setQuotationInformation({
      ...quotationInformation,
      validUntil: formattedDate,
    });
  };

  const handleDeleteTransfer = async (quotationId, bookingId) => {
    try {
      await deleteTransfer(quotationId, bookingId);
      handleGetQuotationDetails(quotationId);
      closeModalDeleteTransferConfirmation();
    } catch (error) {
      console.error("Error fetching quotation details:", error);
    }
  };

  const handleNavigateToTransfer = () => {
    if (quotationId) {
      history.push("/admin/quotations/create/" + quotationId + "/transfer", {
        quotationInformation,
      });
    } else {
      history.push("/admin/quotations/create/transfer");
    }
  };

  const [errorModal, setErrorModal] = useState(false);

  const closeErrorModal = () => setErrorModal(false);

  const openErrorModal = () => setErrorModal(true);

  const [successModal, setSuccessModal] = useState({ show: false, message: "" });

  const closeSuccessModal = () => setSuccessModal({ show: false, message: "" });

  const [modalSubmitConfirmation, setModalSubmitConfirmation] = useState(false);

  const openModalSubmitConfirmation = () => {
    if (
      !quotationInformation.quotationId ||
      !quotationInformation.issueDate ||
      !quotationInformation.validUntil ||
      !fromBillingInformationForm?.selectedClient
    ) {
      alert("Please fill all fields");
      return;
    }
    setModalSubmitConfirmation(true);
  };
  const closeModalSubmitConfirmation = () => setModalSubmitConfirmation(false);

  const handleDiscardEdit = () => {
    handleGetQuotationDetails(quotationId);
    closeModalSubmitConfirmation();
  };

  const handleActiveQuotation = async (status) => {
    try {
      if (!quotationId) {
        // Standalone-items-only: create the Quotation and activate it in one call
        const issueDate = moment.utc(quotationInformation.issueDate, "YYYY-MM-DD").local().format("YYYY-MM-DD");
        const validUntil = moment.utc(quotationInformation.validUntil, "YYYY-MM-DD").local().format("YYYY-MM-DD");

        const res = await createAndActivateQuotation({
          user: fromBillingInformationForm.selectedClient._id,
          quotationID: quotationInformation.quotationId,
          quotationNumber: quotationInformation.bookingReference || null,
          issueDate: new Date(`${issueDate}T00:00:00Z`),
          expiredDate: new Date(`${validUntil}T00:00:00Z`),
          notes: notes || "",
          standaloneItemsGroups: localStandaloneGroups,
          status,
        });

        localStorage.removeItem("quotationData");
        closeModalSubmitConfirmation();
        setSuccessModal({
          show: true,
          message: status === "ACTIVE" ? "The quotation has been activated successfully!" : "The quotation has been saved as draft successfully!",
        });
        history.push(`/admin/quotations/create/${res.id}`);
      } else {
        // Existing quotation with bookings: use the existing activate flow
        await activeQuotation(
          quotationId,
          quotationInformation,
          fromBillingInformationForm.selectedClient,
          notes,
          status,
          bookingDiscounts
        );
        localStorage.removeItem("quotationData");
        closeModalSubmitConfirmation();
        await handleGetQuotationDetails(quotationId);
        window.scrollTo({ top: 0, behavior: "smooth" });
        setSuccessModal({
          show: true,
          message: status === "ACTIVE"
            ? quotationDetail?.quotationStatus === "ACTIVE"
              ? "The quotation has been updated successfully!"
              : "The quotation has been activated successfully!"
            : "The quotation has been saved as draft successfully!",
        });
      }
    } catch (error) {
      closeModalSubmitConfirmation();
      setErrorText(error?.message);
      openErrorModal();
    }
  };

  const [modalDeleteTransferConfirmation, setModalDeleteTransferConfirmation] =
    useState(false);

  const [deleteTransferId, setDeleteTransferId] = useState(null);

  const openModalDeleteTransferConfirmation = (id) => {
    setDeleteTransferId(id);
    setModalDeleteTransferConfirmation(true);
  };

  const closeModalDeleteTransferConfirmation = () =>
    setModalDeleteTransferConfirmation(false);

  const [modalAddClientVisible, setModalAddClient] = useState(false);

  const openModalAddClient = () => setModalAddClient(true);
  const closeModalAddClient = () => setModalAddClient(false);

  const [modalEditClientVisible, setModalEditClient] = useState(false);

  const openModalEditClient = () => setModalEditClient(true);
  const closeModalEditClient = () => setModalEditClient(false);

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("quotationData"));
    if (savedData) {
      setQuotationInformation(savedData.quotationInformation);
      quotationId = savedData.quotationId;
      setFromBillingInformationForm({
        selectedClient: savedData?.selectedClient,
        clientInputText: savedData?.selectedClient?.name,
      });
      setNotes(savedData?.notes);
      if (Array.isArray(savedData?.localStandaloneGroups)) {
        setLocalStandaloneGroups(savedData.localStandaloneGroups);
      }
    }
  }, []);

  useEffect(() => {
    var selectedClient = fromBillingInformationForm.selectedClient;
    const dataToSave = {
      quotationInformation,
      quotationId,
      selectedClient,
      notes,
      // Persist standalone (non-booking) items so they survive navigation to/from
      // the transfer page while the quotation has not been created yet.
      localStandaloneGroups,
    };
    localStorage.setItem("quotationData", JSON.stringify(dataToSave));
  }, [quotationInformation, quotationId, fromBillingInformationForm, notes, localStandaloneGroups]);

  const [modalDetailTransfer, setModalDetailTransfer] = useState(false);

  const [detailTransfer, setDetailTransfer] = useState(null);

  const openModalDetailTransfer = (data) => {
    setDetailTransfer(data);
    setModalDetailTransfer(true);
  };

  const closeModalDetailTransfer = () => setModalDetailTransfer(false);

  const [modalDuplicate, setModalDuplicate] = useState(false);

  const [duplicateTransferId, setDuplicateTransferId] = useState(null);

  const [loadingDuplicate, setLoadingDuplicate] = useState(false);

  const [recurringTravelDates, setRecurringTravelDates] = useState([""]);
  const [inlineAddItemVisible, setInlineAddItemVisible] = useState(false);
  const [selectedBookingIndex, setSelectedBookingIndex] = useState(null);
  const [savingInlineAddItem, setSavingInlineAddItem] = useState(false);
  const [isEditingItems, setIsEditingItems] = useState(false);
  const [confirmRemoveAllVisible, setConfirmRemoveAllVisible] = useState(false);
  const [editingGroupIndex, setEditingGroupIndex] = useState(null);
  const [manualGroup, setManualGroup] = useState({ heading: "", items: [{ serviceDate: "", itemDescription: "", unitPrice: "", qty: "1" }] });

  // Standalone (non-booking) additional items state
  const [standaloneAddItemVisible, setStandaloneAddItemVisible] = useState(false);
  const [isEditingStandaloneItems, setIsEditingStandaloneItems] = useState(false);
  const [editingStandaloneGroupIndex, setEditingStandaloneGroupIndex] = useState(null);
  const [standaloneManualGroup, setStandaloneManualGroup] = useState({ heading: "", items: [{ serviceDate: "", itemDescription: "", unitPrice: "", qty: "1" }] });
  const [savingStandaloneItem, setSavingStandaloneItem] = useState(false);
  const [confirmRemoveStandaloneVisible, setConfirmRemoveStandaloneVisible] = useState(false);

  const [chargeConfirmVisible, setChargeConfirmVisible] = useState(false);
  const [isCharging, setIsCharging] = useState(false);

  // Re-activating an expired quotation: the admin re-issues it, supplying both a
  // new issue date and a new expiry date.
  const [activateModalVisible, setActivateModalVisible] = useState(false);
  const [isActivating, setIsActivating] = useState(false);
  const [activateError, setActivateError] = useState("");
  const [activateIssueDate, setActivateIssueDate] = useState(null);
  const [activateExpiryDate, setActivateExpiryDate] = useState(null);

  // Expiring an active quotation early, before its expiry date is reached.
  const [expireModalVisible, setExpireModalVisible] = useState(false);
  const [isExpiring, setIsExpiring] = useState(false);
  const [expireError, setExpireError] = useState("");

  const getEmptyManualItem = () => ({
    serviceDate: "",
    itemDescription: "",
    unitPrice: "",
    qty: "1",
  });

  const normalizeSignedCurrencyInput = (value) => {
    const raw = String(value ?? "").replace(/,/g, "").trim();
    if (raw === "") return "";

    const isNegative = raw.startsWith("-");
    const digitsOnly = raw.replace(/[^0-9]/g, "");
    if (digitsOnly === "") return isNegative ? "-" : "";

    return `${isNegative ? "-" : ""}${Number(digitsOnly).toLocaleString()}`;
  };

  const parseSignedNumberInput = (value) => {
    const raw = String(value ?? "").replace(/,/g, "").trim();
    if (raw === "" || raw === "-") return 0;
    const isNegative = raw.startsWith("-");
    const digitsOnly = raw.replace(/[^0-9]/g, "");
    if (digitsOnly === "") return 0;
    const numeric = Number(digitsOnly);
    return isNegative ? -numeric : numeric;
  };

  const parseQtyNumberInput = (value) => {
    const digitsOnly = String(value ?? "").replace(/[^0-9]/g, "");
    return digitsOnly === "" ? 0 : Number(digitsOnly);
  };

  const getManualItemAmount = (item) => {
    const unitPrice = parseSignedNumberInput(item.unitPrice);
    const qty = parseQtyNumberInput(item.qty) || 1;
    return unitPrice * qty;
  };

  const openInlineAddItem = (bookingIndex) => {
    const booking = quotationDetail?.bookings?.[bookingIndex];
    setIsEditingItems(false);
    setSelectedBookingIndex(bookingIndex);
    setEditingGroupIndex(null);
    setManualGroup({
      heading: "",
      items: [{ ...getEmptyManualItem(), serviceDate: booking?.travelDate ? moment(booking.travelDate).format("YYYY-MM-DD") : "" }],
    });
    setInlineAddItemVisible(true);
  };

  const openInlineEditGroup = (bookingIndex, groupIndex) => {
    const booking = quotationDetail?.bookings?.[bookingIndex];
    const groups = getAdditionalGroups(booking);
    const group = groups[groupIndex];
    setIsEditingItems(true);
    setSelectedBookingIndex(bookingIndex);
    setEditingGroupIndex(groupIndex);
    setManualGroup({
      heading: group.heading || "",
      items: (group.items || []).map((item) => ({
        serviceDate: item.serviceDate || "",
        itemDescription: item.name || "",
        unitPrice: item.price != null ? normalizeSignedCurrencyInput(String(item.price)) : "",
        qty: item.qty != null ? String(item.qty) : "1",
      })),
    });
    setInlineAddItemVisible(true);
  };

  const closeInlineAddItem = () => {
    setInlineAddItemVisible(false);
    setSelectedBookingIndex(null);
    setIsEditingItems(false);
    setEditingGroupIndex(null);
  };

  // --- Standalone items handlers ---

  // --- Standalone items handlers ---
  // When no quotationId: items are kept in localStandaloneGroups (local state only, no API calls).
  // When quotationId exists: items are persisted immediately via API (existing quotation).
  // The Quotation record is only created when the admin clicks Save (via create-and-activate).

  const effectiveStandaloneGroups = quotationId
    ? (quotationDetail?.standaloneItemsGroups || [])
    : localStandaloneGroups;

  const openStandaloneAddItem = () => {
    setIsEditingStandaloneItems(false);
    setEditingStandaloneGroupIndex(null);
    setStandaloneManualGroup({ heading: "", items: [{ ...getEmptyManualItem() }] });
    setStandaloneAddItemVisible(true);
  };

  const openStandaloneEditGroup = (groupIndex) => {
    const groups = effectiveStandaloneGroups;
    const group = groups[groupIndex];
    setIsEditingStandaloneItems(true);
    setEditingStandaloneGroupIndex(groupIndex);
    setStandaloneManualGroup({
      heading: group.heading || "",
      items: (group.items || []).map((item) => ({
        serviceDate: item.serviceDate || "",
        itemDescription: item.name || "",
        unitPrice: item.price != null ? normalizeSignedCurrencyInput(String(item.price)) : "",
        qty: item.qty != null ? String(item.qty) : "1",
      })),
    });
    setStandaloneAddItemVisible(true);
  };

  const closeStandaloneAddItem = () => {
    setStandaloneAddItemVisible(false);
    setIsEditingStandaloneItems(false);
    setEditingStandaloneGroupIndex(null);
  };

  const handleStandaloneGroupHeadingChange = (value) => {
    setStandaloneManualGroup((prev) => ({ ...prev, heading: value }));
  };

  const handleStandaloneItemFieldChange = (itemIndex, key, value) => {
    setStandaloneManualGroup((prev) => ({
      ...prev,
      items: prev.items.map((item, ii) => {
        if (ii !== itemIndex) return item;
        if (key === "unitPrice") return { ...item, unitPrice: normalizeSignedCurrencyInput(value) };
        if (key === "qty") return { ...item, qty: String(value ?? "").replace(/[^0-9]/g, "") };
        return { ...item, [key]: value };
      }),
    }));
  };

  const handleStandaloneItemServiceDateChange = (date, itemIndex) => {
    handleStandaloneItemFieldChange(itemIndex, "serviceDate", date);
  };

  const addStandaloneItemRow = () => {
    setStandaloneManualGroup((prev) => ({ ...prev, items: [...prev.items, getEmptyManualItem()] }));
  };

  const removeStandaloneItemRow = (itemIndex) => {
    setStandaloneManualGroup((prev) => {
      if (prev.items.length === 1) return prev;
      return { ...prev, items: prev.items.filter((_, ii) => ii !== itemIndex) };
    });
  };

  const normalizeStandaloneGroup = (group) => ({
    heading: group.heading?.trim() || "",
    items: group.items.map((item) => {
      const price = parseSignedNumberInput(item.unitPrice);
      const rawQty = String(item.qty ?? "").trim();
      const qty = rawQty === "" ? undefined : parseQtyNumberInput(rawQty);
      const effectiveQty = qty === null ? "" : (qty || 1);
      return {
        serviceDate: item.serviceDate,
        name: item.itemDescription?.trim(),
        price,
        qty: rawQty === "" ? undefined : qty,
        totalPrice: price * effectiveQty,
      };
    }),
  });

  const submitStandaloneItems = async () => {
    const hasInvalidData = standaloneManualGroup.items.some((item) => {
      const unitPriceInput = String(item.unitPrice ?? "").trim();
      return !item.itemDescription?.trim() || unitPriceInput === "" || unitPriceInput === "-";
    });

    if (hasInvalidData) {
      alert("Please complete Item Name/Description and Unit Price with valid values.");
      return;
    }

    let newGroups;
    if (editingStandaloneGroupIndex !== null) {
      newGroups = effectiveStandaloneGroups.map((g, i) =>
        i === editingStandaloneGroupIndex ? normalizeStandaloneGroup(standaloneManualGroup) : g
      );
    } else {
      newGroups = [...effectiveStandaloneGroups, normalizeStandaloneGroup(standaloneManualGroup)];
    }

    if (!quotationId) {
      // No quotation yet — just update local state; Quotation will be created on Save
      setLocalStandaloneGroups(newGroups);
      closeStandaloneAddItem();
      return;
    }

    // Quotation exists — persist to backend immediately
    try {
      setSavingStandaloneItem(true);
      await addStandaloneItems({ quotationId, groups: newGroups });
      await handleGetQuotationDetails(quotationId);
      closeStandaloneAddItem();
    } catch (error) {
      alert(error?.response?.data?.errors?.[0] || error?.message || "Failed to add items.");
    } finally {
      setSavingStandaloneItem(false);
    }
  };

  const removeAllStandaloneItems = async () => {
    if (!quotationId) {
      // Local state only — remove all or the specific group being edited
      if (editingStandaloneGroupIndex !== null) {
        setLocalStandaloneGroups((prev) => prev.filter((_, i) => i !== editingStandaloneGroupIndex));
      } else {
        setLocalStandaloneGroups([]);
      }
      closeStandaloneAddItem();
      setConfirmRemoveStandaloneVisible(false);
      return;
    }

    try {
      setSavingStandaloneItem(true);
      if (editingStandaloneGroupIndex !== null) {
        const remaining = effectiveStandaloneGroups.filter((_, i) => i !== editingStandaloneGroupIndex);
        if (remaining.length === 0) {
          await removeStandaloneItems({ quotationId });
        } else {
          await addStandaloneItems({ quotationId, groups: remaining });
        }
      } else {
        await removeStandaloneItems({ quotationId });
      }
      await handleGetQuotationDetails(quotationId);
      closeStandaloneAddItem();
      setConfirmRemoveStandaloneVisible(false);
    } catch (error) {
      alert(error?.response?.data?.errors?.[0] || error?.message || "Failed to remove items.");
    } finally {
      setSavingStandaloneItem(false);
    }
  };

  // --- End standalone items handlers ---

  const addManualQuotationItemRow = () => {
    setManualGroup((prev) => ({ ...prev, items: [...prev.items, getEmptyManualItem()] }));
  };

  const removeManualQuotationItemRow = (itemIndex) => {
    setManualGroup((prev) => {
      if (prev.items.length === 1) return prev;
      return { ...prev, items: prev.items.filter((_, ii) => ii !== itemIndex) };
    });
  };

  const handleManualGroupHeadingChange = (value) => {
    setManualGroup((prev) => ({ ...prev, heading: value }));
  };

  const handleManualItemFieldChange = (itemIndex, key, value) => {
    setManualGroup((prev) => ({
      ...prev,
      items: prev.items.map((item, ii) => {
        if (ii !== itemIndex) return item;
        if (key === "unitPrice") return { ...item, unitPrice: normalizeSignedCurrencyInput(value) };
        if (key === "qty") return { ...item, qty: String(value ?? "").replace(/[^0-9]/g, "") };
        return { ...item, [key]: value };
      }),
    }));
  };

  const handleManualItemServiceDateChange = (date, itemIndex) => {
    handleManualItemFieldChange(itemIndex, "serviceDate", date);
  };

  const recalculateQuotationTotals = (currentQuotationDetail) => {
    const nextQuotationDetail = JSON.parse(JSON.stringify(currentQuotationDetail));
    let totalAmount = 0;
    let discountedTotalAmount = 0;

    nextQuotationDetail.bookings = (nextQuotationDetail.bookings || []).map((booking) => {
      const bookingBaseTotal = (booking.bookingItems || []).reduce(
        (sum, bookingItem) => sum + Number(bookingItem?.totalPrice || 0),
        0
      );

      const bookingDiscountedTotal = (booking.bookingItems || []).reduce(
        (sum, bookingItem) => sum + Number(bookingItem?.discountedPrice ?? bookingItem?.totalPrice ?? 0),
        0
      );

      totalAmount += bookingBaseTotal;
      discountedTotalAmount += bookingDiscountedTotal;

      return {
        ...booking,
        totalPrice: bookingBaseTotal,
      };
    });

    nextQuotationDetail.totalAmount = totalAmount;
    if (nextQuotationDetail.useDiscount) {
      nextQuotationDetail.discountedTotalAmount = discountedTotalAmount;
      nextQuotationDetail.totalDiscount = totalAmount - discountedTotalAmount;
    }

    return nextQuotationDetail;
  };

  const submitManualQuotationItems = async () => {
    if (selectedBookingIndex === null || selectedBookingIndex === undefined) return;

    const hasInvalidData = manualGroup.items.some((item) => {
      const unitPriceInput = String(item.unitPrice ?? "").trim();
      return !item.itemDescription?.trim() || unitPriceInput === "" || unitPriceInput === "-";
    });

    if (hasInvalidData) {
      alert("Please complete Item Name/Description and Unit Price with valid values.");
      return;
    }

    const selectedBooking = quotationDetail?.bookings?.[selectedBookingIndex];
    const bookingId = selectedBooking?._id;

    if (!bookingId) {
      alert("Booking ID is not available.");
      return;
    }

    const normalizeGroup = (group) => ({
      heading: group.heading?.trim() || "",
      items: group.items.map((item) => {
        const price = parseSignedNumberInput(item.unitPrice);
        const rawQty = String(item.qty ?? "").trim();
        const qty = rawQty === "" ? undefined : parseQtyNumberInput(rawQty);
        const effectiveQty = qty === null ? "" : (qty || 1);
        return {
          serviceDate: item.serviceDate,
          name: item.itemDescription?.trim(),
          price,
          qty: rawQty === "" ? undefined : qty,
          totalPrice: price * effectiveQty,
        };
      }),
    });

    const existingGroups = getAdditionalGroups(selectedBooking);
    let newGroups;
    if (editingGroupIndex !== null) {
      newGroups = existingGroups.map((g, i) => i === editingGroupIndex ? normalizeGroup(manualGroup) : g);
    } else {
      newGroups = [...existingGroups, normalizeGroup(manualGroup)];
    }

    const reqBody = {
      bookingId,
      groups: newGroups,
    };

    try {
      setSavingInlineAddItem(true);
      await addQuotationItems(reqBody);
      await handleGetQuotationDetails(quotationId);
      closeInlineAddItem();
    } catch (error) {
      alert(error?.response?.data?.errors?.[0] || error?.message || "Failed to add items.");
    } finally {
      setSavingInlineAddItem(false);
    }
  };

  const removeAllItemsQuotation = async () => {
    if (selectedBookingIndex === null || selectedBookingIndex === undefined) return;

    const selectedBooking = quotationDetail?.bookings?.[selectedBookingIndex];
    const bookingId = selectedBooking?._id;

    if (!bookingId) {
      alert("Booking ID is not available.");
      return;
    }

    try {
      setSavingInlineAddItem(true);

      if (editingGroupIndex !== null) {
        const existingGroups = getAdditionalGroups(selectedBooking);
        const remainingGroups = existingGroups.filter((_, i) => i !== editingGroupIndex);
        if (remainingGroups.length === 0) {
          await removeAllItems({ bookingId });
        } else {
          await addQuotationItems({ bookingId, groups: remainingGroups });
        }
      } else {
        await removeAllItems({ bookingId });
      }

      await handleGetQuotationDetails(quotationId);
      closeInlineAddItem();
      setConfirmRemoveAllVisible(false);
    } catch (error) {
      alert(error?.response?.data?.errors?.[0] || error?.message || "Failed to remove items.");
    } finally {
      setSavingInlineAddItem(false);
    }
  };

  const handleSelectTravelDate = (date, index) => {
    const formattedDate = moment(date).format("YYYY-MM-DD");
    setRecurringTravelDates((prevDates) => {
      if (prevDates[index] !== undefined) {
        const updatedDates = [...prevDates];
        updatedDates[index] = formattedDate;
        return updatedDates;
      }
      return prevDates;
    });
  };
  const addReccuringTravelDate = () => {
    setRecurringTravelDates([...recurringTravelDates, ""]);
  };

  const removeReccuringTravelDate = (index) => {
    if (recurringTravelDates?.length > 1) {
      setRecurringTravelDates((recurringTravelDates) => [
        ...recurringTravelDates.slice(0, index),
        ...recurringTravelDates.slice(index + 1),
      ]);
    }
  };

  const openModalDuplicate = (id) => {
    setRecurringTravelDates([""]);
    setDuplicateTransferId(id);
    setModalDuplicate(true);
  };

  const closeModalDuplicate = () => setModalDuplicate(false);

  const handleDuplicateTransfer = async () => {
    try {
      setLoadingDuplicate(true);
      const filteredTravelDates = recurringTravelDates.filter(
        (date) => date.trim() !== ""
      );
      if (filteredTravelDates?.length > 0) {
        var resDuplicate = await duplicateBooking({
          quotationId: quotationId,
          bookingId: duplicateTransferId,
          duplicateDate: filteredTravelDates,
        });
        await handleGetQuotationDetails(quotationId);
        closeModalDuplicate();
      }
    } catch (error) {
      alert("Failed to duplicate");
    } finally {
      setLoadingDuplicate(false);
    }
  };

  // Step 1: the admin clicks an "Order by" button -> ask for confirmation first.
  const openSortOrderConfirmation = (newSortOrder) => {
    if (newSortOrder === bookingSortOrder) return; // already in this order
    setSortOrderError("");
    setPendingBookingSortOrder(newSortOrder);
  };

  const closeSortOrderConfirmation = () => {
    setPendingBookingSortOrder(null);
    setSortOrderError("");
  };

  // Step 2: the admin confirms -> save the order, then reorder the page.
  const handleConfirmBookingSortOrder = async () => {
    try {
      setIsSavingSortOrder(true);
      setSortOrderError("");
      const { sortedBookingIds } = await saveBookingSortOrder(quotationId, pendingBookingSortOrder);

      setBookingSortOrder(pendingBookingSortOrder);

      // The inline "Add Item" form remembers its booking by list position, so
      // close it before the positions change.
      closeInlineAddItem();

      // Reorder the bookings stored in state (not only what is displayed) so the
      // Transfer List and the Quotation Items table always show the same order.
      // We don't reload from the server, so unsaved discount changes are kept.
      setQuotationDetail((previousDetail) => {
        if (!previousDetail) return previousDetail;
        return {
          ...previousDetail,
          bookings: orderBookingsByIds(previousDetail.bookings, sortedBookingIds),
        };
      });

      setPendingBookingSortOrder(null);
    } catch (error) {
      setSortOrderError(error?.message || "Failed to save the transfer order.");
    } finally {
      setIsSavingSortOrder(false);
    }
  };

  const handleNavigateToEditTransfer = async (item) => {
    localStorage.setItem("editTransferData", JSON.stringify(item));
    handleNavigateToTransfer();
  };


  // Recompute the quotation preview from a per-transfer rate map:
  // { [bookingId]: rate }. Each vehicle item in a booking uses that booking's
  // own rate; a rate of 0 (or missing) leaves the transfer at its original price.
  const computeDiscountedQuotation = (discountsMap) => {
    const updatedQuotationDetail = JSON.parse(JSON.stringify(quotationDetail));
    let totalDiscount = 0;

    updatedQuotationDetail.bookings.forEach(booking => {
      const rate = Number(discountsMap?.[String(booking._id)] || 0);
      let bookingTotalDiscount = 0;

      booking.bookingItems.forEach(item => {
        if (item.type === "vehicle") {
          if (rate > 0) {
            const tollFeeAmount = item?.details?.find(det => det.id === "tollFee" || det.name === "Toll Fee")?.amount || 0;
            const longDistanceSurchargeAmount = item?.details?.find(det => det.id === "longDistanceSurcharge" || det.name === "Long Distance Surcharge")?.amount || 0;
            const discountableAmount = item.totalPrice - tollFeeAmount - longDistanceSurchargeAmount;
            const itemDiscount = Math.ceil(rate / 100 * discountableAmount);
            item.discount = rate;
            item.totalDiscount = itemDiscount;
            item.discountedPrice = Math.ceil((discountableAmount - itemDiscount) + tollFeeAmount + longDistanceSurchargeAmount);

            totalDiscount += itemDiscount;
            bookingTotalDiscount += itemDiscount;
          } else {
            // Transfer has no discount — strip any previous discount.
            delete item.discount;
            delete item.totalDiscount;
            delete item.discountedPrice;
          }
        }
      });

      if (rate > 0) {
        booking.useDiscount = true;
        booking.discount = rate;
        booking.totalDiscount = bookingTotalDiscount;
        booking.discountedPrice = booking.totalPrice - bookingTotalDiscount;
      } else {
        booking.useDiscount = false;
        delete booking.discount;
        delete booking.totalDiscount;
        delete booking.discountedPrice;
      }
    });

    updatedQuotationDetail.discountedTotalAmount = updatedQuotationDetail.totalAmount - totalDiscount
    updatedQuotationDetail.useDiscount = totalDiscount > 0
    updatedQuotationDetail.totalDiscount = totalDiscount

    return updatedQuotationDetail;
  }

  const applyDiscount = (discountsMap) => {
    setQuotationDetail(computeDiscountedQuotation(discountsMap));
    setIsDiscountApplied(Object.values(discountsMap).some((rate) => Number(rate) > 0));
  }

  // "Apply to all": push the global rate onto every transfer.
  const applyDiscountHandler = () => {
    const newMap = {};
    (quotationDetail?.bookings || []).forEach((booking) => {
      newMap[String(booking._id)] = discount;
    });
    setBookingDiscounts(newMap);
    applyDiscount(newMap);
  }

  // Enable discounted view; keep any per-transfer rates already set.
  const enableDiscountView = () => {
    setShowDiscounted(true);
  };

  // Update a single transfer's rate (overrides the global rate for that transfer).
  const handleChangeBookingDiscountRate = (bookingId, value) => {
    const newRate = value === "" ? 0 : Number(value);
    if (Number.isNaN(newRate) || newRate < 0 || newRate > 100) return;

    const newMap = { ...bookingDiscounts, [String(bookingId)]: newRate };
    setBookingDiscounts(newMap);
    applyDiscount(newMap);
  };

  const resetDiscount = () => {
    setShowDiscounted(false);

    setIsDiscountApplied(false);

    setDiscount(0);

    setBookingDiscounts({});

    setQuotationDetail(prevState => {
      const newState = JSON.parse(JSON.stringify(prevState));

      newState?.bookings?.forEach(booking => {
        booking?.bookingItems?.forEach(item => {
          if (item.type === "vehicle") {
            delete item.discount;
            delete item.totalDiscount;
            delete item.discountedPrice;
          }
        });
        booking.useDiscount = false;
        delete booking.discount;
        delete booking.totalDiscount;
        delete booking.discountedPrice;
      });

      delete newState.discountedTotalAmount
      delete newState.useDiscount
      delete newState.totalDiscount
      delete newState.discount

      return newState;
    });
  }

  const handleChargeQuotation = async () => {
    try {
      setIsCharging(true);
      await chargeQuotation(quotationId);
      setChargeConfirmVisible(false);
      await handleGetQuotationDetails(quotationId);
      setSuccessModal({ show: true, message: "Quotation charged successfully!" });
    } catch (error) {
      setChargeConfirmVisible(false);
      setErrorText(error?.response?.data?.message || error?.message || "Failed to charge quotation.");
      openErrorModal();
    } finally {
      setIsCharging(false);
    }
  };

  const openActivateModal = () => {
    // Re-activating re-issues the quotation, so it is issued today and, by
    // default, expires a week out — the expired date itself is never a valid choice.
    setActivateIssueDate(moment().format("YYYY-MM-DD"));
    setActivateExpiryDate(moment().add(7, "days").format("YYYY-MM-DD"));
    setActivateError("");
    setActivateModalVisible(true);
  };

  const closeActivateModal = () => {
    if (isActivating) return;
    setActivateModalVisible(false);
    setActivateError("");
  };

  const handleReactivateQuotation = async () => {
    if (!activateIssueDate) {
      setActivateError("Please select a new issue date.");
      return;
    }

    if (!activateExpiryDate) {
      setActivateError("Please select a new expiry date.");
      return;
    }

    if (moment(activateIssueDate, "YYYY-MM-DD").isAfter(moment(activateExpiryDate, "YYYY-MM-DD"))) {
      setActivateError("The issue date cannot be after the expiry date.");
      return;
    }

    try {
      setIsActivating(true);
      setActivateError("");
      await reactivateQuotation(quotationId, activateIssueDate, activateExpiryDate);
      setActivateModalVisible(false);
      await handleGetQuotationDetails(quotationId);
      window.scrollTo({ top: 0, behavior: "smooth" });
      setSuccessModal({
        show: true,
        message: "The quotation has been reactivated successfully!",
      });
    } catch (error) {
      setActivateError(error?.message || "Failed to reactivate quotation.");
    } finally {
      setIsActivating(false);
    }
  };

  const openExpireModal = () => {
    setExpireError("");
    setExpireModalVisible(true);
  };

  const closeExpireModal = () => {
    if (isExpiring) return;
    setExpireModalVisible(false);
    setExpireError("");
  };

  const handleExpireQuotation = async () => {
    try {
      setIsExpiring(true);
      setExpireError("");
      await expireQuotation(quotationId);
      setExpireModalVisible(false);
      await handleGetQuotationDetails(quotationId);
      window.scrollTo({ top: 0, behavior: "smooth" });
      setSuccessModal({
        show: true,
        message: "The quotation has been deactivated successfully!",
      });
    } catch (error) {
      setExpireError(error?.message || "Failed to deactivate quotation.");
    } finally {
      setIsExpiring(false);
    }
  };

  const onSuccessAddClient = async (response) => {
    closeModalAddClient();
    setFromBillingInformationForm({
      selectedClient: response.data.user,
      clientInputText: response.data.user.name,
    });
  };

  const onFailedAddNewClient = async (e) => {
    console.error(e);
    const errorMessage =
      e.response?.data?.errors?.msg || "Failed to add client!";
    setErrorText(errorMessage);
    openErrorModal();
  };

  const onSuccessEditClient = (response) => {
    closeModalEditClient();
    setFromBillingInformationForm({
      selectedClient: response.data.user,
      clientInputText: response.data.user.name,
    });
  };

  const onFailedEditClient = (e) => {
    closeModalEditClient();
    const errorMessage =
      e.response?.data?.errors?.msg || "Failed to update client!";
    setErrorText(errorMessage);
    openErrorModal();
  };

  const handleClientSearchInputClick = () => {
    if (fromBillingInformationForm.selectedClient) {
      setFromBillingInformationForm({ selectedClient: null, clientInputText: "" });
      getClients("");
    }
  };

  // Global rate input — only stores the value; it is pushed onto the transfers
  // when the admin clicks "Apply to all".
  const handleChangeDiscountRate = (e) => {
    const newRate = e.target.value === "" ? 0 : Number(e.target.value);
    if (Number.isNaN(newRate) || newRate < 0) return;
    if (newRate > 100) return;

    setDiscount(newRate);
  }

  const getStatusBadge = (quotation) => {
    // Keep this in sync with Item.js getStatusBadge so the list and detail
    // show the same status.
    // paymentStatus flow: NOT_PAID -> READY_TO_CHARGE -> CHARGE_INITIATED -> CHARGED
    // (CHARGE_FAILED on failure). PAID is legacy old data — already paid, terminal.
    if (quotation?.paymentStatus === "CHARGED") return { className: "bg-green text-white", label: "Charged" };
    if (quotation?.paymentStatus === "CHARGE_INITIATED") return { className: "bg-blue text-white", label: "Charge Processing" };
    if (quotation?.paymentStatus === "READY_TO_CHARGE") return { className: "bg-gold text-white", label: "Ready To Charge" };
    if (quotation?.paymentStatus === "CHARGE_FAILED") return { className: "bg-EA4335 text-white", label: "Charge Failed" };
    if (quotation?.paymentStatus === "PAID") return { className: "bg-green text-white", label: "Paid" };
    if (quotation?.quotationStatus === "DRAFT") return { className: "bg-DADADA", label: "Draft" };
    if (quotation?.quotationStatus === "ACTIVE" && quotation?.paymentStatus === "NOT_PAID") return { className: "bg-blue text-white", label: "Active - Not paid" };
    if (quotation?.quotationStatus === "EXPIRED") return { className: "bg-EA4335 text-white", label: "Expired" };
    return { className: "", label: "" };
  };

  const { className: statusClassName, label: statusLabel } = getStatusBadge(quotationDetail);

  const checkNotes = (booking) => {
    const message = booking?.message?.find(
      (msg) => msg?.isAdmin === false && msg?.note?.trim() !== ""
    );

    if (message) {
      return {
        available: true,
        note: message.note,
      };
    }

    return {
      available: false,
      note: "",
    };
  };

  // Once the customer has authorized payment (anything past NOT_PAID) the
  // quotation is locked and its Booking records exist, so transfers link to
  // the booking detail instead of being editable.
  const isPaymentLocked = (
    Boolean(quotationDetail?.paymentStatus) &&
    quotationDetail.paymentStatus !== "NOT_PAID"
  );

  const isDisableEdit = (
    isPaymentLocked ||
    quotationDetail?.quotationStatus === "EXPIRED"
  );

  // An expired quotation can be brought back to life by re-issuing it with new
  // dates — but only while the customer has not authorized payment on it.
  const canReactivate = (
    Boolean(quotationId) &&
    quotationDetail?.quotationStatus === "EXPIRED" &&
    !isPaymentLocked
  );

  // An active quotation can be expired early, as long as the customer has not
  // authorized payment on it yet. Reactivate undoes it.
  const canExpire = (
    Boolean(quotationId) &&
    quotationDetail?.quotationStatus === "ACTIVE" &&
    !isPaymentLocked
  );

  // Bookings an admin already charged on their own while editing them. The backend
  // leaves them out of this quotation's charge, so the page shows them and the remainder.
  const separatelyChargedBookings = quotationDetail?.separatelyChargedBookings || [];
  const separatelyChargedTotal = Number(quotationDetail?.separatelyChargedTotal || 0);
  const remainingChargeAmount = Number(
    quotationDetail?.remainingChargeAmount ?? quotationDetail?.totalAmount ?? 0
  );

  // Same rule as the download page, the customer link and the PDF, so all four
  // always show one total. See _utils/quotationTotals.js.
  const computedTotalAmount = computeQuotationTotalAmount(quotationDetail, effectiveStandaloneGroups);

  return (
    <>
      <Layout>
        <main
          className="col-md-9 ms-sm-auto col-lg-10 px-md-4 py-4 w-100"
          style={{ backgroundColor: "#F6F6F6" }}
        >
          <div id="header" className="mb-3">
            <div
              className="d-inline-flex align-items-center gap-2 pointer"
              onClick={() => history.push("/admin/quotations")}
            >
              <BackAltIcon
                width={"10px"}
                height={"10px"}
              />
              <p className="noto m-0">Back </p>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3">
              <div className="d-flex align-items-center gap-3">
                <label className="tw:!text-[26px] tw:font-[600] mb-0">Quotation</label>
                {statusLabel && (
                  <div className={`text-center ${statusClassName} rounded px-3 py-1 fs-14`}>
                    {statusLabel}
                  </div>
                )}
              </div>
              <div className="d-flex align-items-stretch justify-content-end gap-2">
                <div className="col-auto">
                  <button
                    className="btn btn-dark rounded px-3"
                    onClick={() =>
                      history.push(`/admin/quotations/download/${quotationId}`)
                    }
                  >
                    <div className="d-flex align-items-center gap-2 fs-14">
                      <p className="m-0 text-white pointer">
                        Download
                      </p>
                      <DownloadAltIcon color="#FFFFFF" />
                    </div>
                  </button>
                </div>
                <div className="col-auto">
                  <button
                    className="btn btn-primary rounded px-3"
                    disabled={
                      quotationId == null ||
                        quotationDetail?.quotationStatus === "UNSAVED"
                        ? true
                        : false
                    }
                    onClick={() => history.push("/quotation/" + quotationId)}
                  >
                    <div className="d-flex align-items-center gap-2 fs-14">
                      <p className="m-0 text-white pointer">Quotation Link</p>
                      <ArrowOutwardIcon />
                    </div>
                  </button>
                </div>
                {canExpire && (
                  <div className="col-auto">
                    <button
                      className="btn bg-EA4335 rounded px-3"
                      onClick={openExpireModal}
                    >
                      <div className="d-flex align-items-center gap-2 fs-14">
                        <p className="m-0 text-white pointer">Deactivate</p>
                      </div>
                    </button>
                  </div>
                )}
                {canReactivate && (
                  <div className="col-auto">
                    <button
                      className="btn bg-green rounded px-3"
                      onClick={openActivateModal}
                    >
                      <div className="d-flex align-items-center gap-2 fs-14">
                        <p className="m-0 text-white pointer">Reactivate</p>
                      </div>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          {isLoading ? (
            <QuotationDetailSkeleton />
          ) : (
            <div id="body">
              <ChargeFailedNotice quotation={quotationDetail} />
              <div className="accordion mb-4" id="billingInformation">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="billingInformationLabel">
                    <button
                      className="accordion-button with-arrow-2 bg-white"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#billingInformationItem"
                      aria-expanded="true"
                      aria-controls="billingInformationItem"
                    >
                      Billing Information
                    </button>
                  </h2>
                  <div
                    id="billingInformationItem"
                    className="accordion-collapse collapse show"
                    aria-labelledby="billingInformationLabel"
                    data-bs-parent="#billingInformation"
                  >
                    <div className="p-3">
                      <div className="row">
                        <div className="col-md-6">
                          <p htmlFor="" className="tw:text-[12px]! mb-2 text-muted">
                            TO
                          </p>
                          <div className="row mb-3">
                            <div className="col-md-12">
                              <AdminInput
                                suffixIcon={<SelectArrowIcon />}
                                placeholder="Select Client"
                                mb="mb-1"
                                onChange={handleSearchClient}
                                onClick={handleClientSearchInputClick}
                                value={fromBillingInformationForm.clientInputText}
                                disable={isDisableEdit}
                              />
                              {fromBillingInformationForm.selectedClient ==
                                null && (
                                  <div className="border rounded">
                                    <div
                                      className="overflow-auto"
                                      style={{
                                        maxHeight: "205px",
                                        minHeight: "0px",
                                      }}
                                    >
                                      {clients?.map((item) => (
                                        <div
                                          className="border-bottom hover pointer"
                                          onClick={() => handleSelectClient(item)}
                                        >
                                          <div className="d-flex align-items-center gap-2 px-2 py-3">
                                            <UserIcon />
                                            <div className="">
                                              <p className=" fs-13 mb-0">
                                                {item.name}
                                              </p>
                                              <p className="fs-13 mb-1 text-8D8D8D">
                                                Mail : {item.email} | Tel.{" "}
                                                {getPhoneNumber(item)}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                    <div
                                      className="bg-gold-FFF8E8 pointer px-2 py-3"
                                      onClick={openModalAddClient}
                                    >
                                      <div className="d-flex align-items-center gap-2">
                                        <AddAltIcon />
                                        <p className="m-0">Add New Client</p>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              {fromBillingInformationForm.selectedClient && (
                                <>
                                  <div className="bg-gold-FFF8E8 rounded p-3 mt-2">
                                    <div className="d-flex justify-content-between align-items-start">
                                      <table cellPadding={15}>
                                        <tr>
                                          <td className="text-7C7B7B pe-4 align-top">Email</td>
                                          <td>
                                            {
                                              fromBillingInformationForm.selectedClient.email
                                            }
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-7C7B7B pe-4 align-top">Billing Address</td>
                                          <td>
                                            {
                                              fromBillingInformationForm.selectedClient.role === "individual"
                                                ? (fromBillingInformationForm.selectedClient?.individualDetail?.billingInformation?.address || '-')
                                                : (fromBillingInformationForm.selectedClient?.businessDetail?.billingInformation?.address || '-')
                                            }
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-7C7B7B pe-4 align-top">Tel.</td>
                                          <td>
                                            {getPhoneNumber(
                                              fromBillingInformationForm.selectedClient
                                            )}
                                          </td>
                                        </tr>
                                      </table>
                                      <button
                                        className="btn bg-gold rounded px-4"
                                        disabled={isDisableEdit}
                                        onClick={openModalEditClient}
                                      >
                                        Edit
                                      </button>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <p htmlFor="" className="tw:text-[12px]! tw:mb-2! text-muted">
                            FROM
                          </p>
                          <b className="text-4E4E4E">
                            THE LUXURY FLEET Co., Ltd.
                          </b>
                          <div className="bg-F5F5F5 p-3 mt-4">
                            <div className="d-flex justify-content-between">
                              <div className="col">
                                <table className="table">
                                  <tr>
                                    <td className="text-7C7B7B pe-4 align-top">
                                      Email
                                    </td>
                                    <td className="text-secondary">
                                      info@theluxuryfleet.com
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="text-7C7B7B pe-4 align-top">
                                      Tax No.
                                    </td>
                                    <td className="text-secondary">
                                      T2010401114998
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="text-7C7B7B pe-4 align-top">
                                      Address
                                    </td>
                                    <td className="text-secondary">
                                      Dai 2 Hayashi Building 1F/2F, Kitashinagawa
                                      1-8-20, Shinagawa-ku, Tokyo 140-0001 Japan
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="text-7C7B7B pe-4 align-top">
                                      Tel.
                                    </td>
                                    <td className="text-secondary">
                                      (+81) 3-6822-8772
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion mb-4" id="quotationformation">
                <div className="accordion-item ">
                  <h2 className="accordion-header" id="quotationformationLabel">
                    <button
                      className="accordion-button with-arrow-2 bg-white px-3"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#quotationformationItem"
                      aria-expanded="true"
                      aria-controls="quotationformationItem"
                    >
                      Quotation Information
                    </button>
                  </h2>
                  <div
                    id="quotationformationItem"
                    className="accordion-collapse collapse show"
                    aria-labelledby="quotationformationLabel"
                    data-bs-parent="#quotationformation"
                  >
                    <div className="p-3">
                      <div className="row">
                        <div className="col-md-3">
                          <label className="mb-2 fs-14">Quotation ID</label>
                          <AdminInput
                            placeholder="Enter Quotation ID"
                            value={quotationInformation.quotationId}
                            onChange={handleQuotationInformationChange}
                            name="quotationId"
                            disable={isDisableEdit}
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="mb-2 fs-14">
                            Booking Reference No.
                            <span className="text-muted">(issued by client)</span>
                          </label>
                          <AdminInput
                            placeholder="Booking Reference No."
                            value={quotationInformation.bookingReference}
                            onChange={handleQuotationInformationChange}
                            name="bookingReference"
                            disable={isDisableEdit}
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="mb-2 fs-14">Issue Date</label>
                          <AdminInputDatePicker
                            placeholder="Select Issue Date"
                            prefixIcon={<CalendarAltIcon />}
                            onSelectDate={
                              handleIssueDateQuotationInformationChange
                            }
                            mb={""}
                            name="issueDate"
                            value={
                              quotationInformation.issueDate !== null
                                ? moment(
                                  quotationInformation.issueDate,
                                  "YYYY-MM-DD"
                                ).toDate() : null
                            }
                            disable={isDisableEdit}
                            dateFormat="MMMM d, yyyy"
                          />
                        </div>
                        <div className="col-md-3">
                          <label className="mb-2 fs-14">Expiry Date</label>
                          <AdminInputDatePicker
                            placeholder="Select Expiry Date"
                            prefixIcon={<CalendarAltIcon />}
                            onSelectDate={
                              handleValidUntilQuotationInformationChange
                            }
                            mb={""}
                            name="validUntil"
                            value={
                              quotationInformation.validUntil !== null
                                ? moment(
                                  quotationInformation.validUntil,
                                  "YYYY-MM-DD"
                                ).toDate() : null
                            }
                            disable={isDisableEdit}
                            minDate={new Date()}
                            dateFormat="MMMM d, yyyy"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion mb-4" id="transferList">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="transferListLabel">
                    <button
                      className="accordion-button with-arrow-2 bg-white px-3"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#transferListItem"
                      aria-expanded="true"
                      aria-controls="transferListItem"
                    >
                      Transfer List
                    </button>
                  </h2>
                  <div
                    id="transferListItem"
                    className="accordion-collapse collapse show"
                    aria-labelledby="transferListLabel"
                    data-bs-parent="#transferList"
                  >
                    <div className="p-3">
                      {/* Ordering only matters once there are at least two transfers. */}
                      {quotationDetail?.bookings?.length > 1 && (
                        <div className="tw:flex tw:items-center tw:justify-end tw:gap-2 tw:mb-3">
                          <p className="m-0 fs-13 text-A7A7A7">Order by</p>
                          {BOOKING_SORT_OPTIONS.map((option) => {
                            const isSelected = bookingSortOrder === option.value;
                            return (
                              <button
                                key={option.value}
                                type="button"
                                className={`btn rounded fs-13 px-3 ${isSelected ? "bg-gold text-white" : "btn-outline-default"}`}
                                aria-pressed={isSelected}
                                onClick={() => openSortOrderConfirmation(option.value)}
                              >
                                {option.label}
                              </button>
                            );
                          })}
                        </div>
                      )}
                      {quotationDetail?.bookings?.map((item, index) => (
                        <div className="border rounded p-3 mb-2" key={index}>
                          <div className="row">
                            <div className="col-2">
                              <p className=" fs-11 text-A7A7A7 mb-1">
                                Travel Date
                              </p>
                              <p className="m-0 fs-14 text-4E4E4E">
                                {formatTravelDate(item.travelDate)}
                              </p>
                            </div>
                            <div className="col-2">
                              <p className=" fs-11 text-A7A7A7 mb-1">
                                Transfer Type
                              </p>
                              <p className="m-0 fs-14 text-4E4E4E">
                                {getBookingType(
                                  item?.bookingType,
                                  item?.isAirportTransfer
                                )}
                              </p>
                            </div>
                            <div className="col-2">
                              <p className=" fs-11 text-A7A7A7 mb-1">
                                Description
                              </p>
                              <p className="m-0 fs-14 text-4E4E4E">
                                {`${item?.pickupLocation ? item?.pickupLocation?.label?.split(",")[0] : "Undecided"} ⇒ ${item?.destinations?.length > 0 ? item?.destinations[item?.destinations?.length - 1]?.label?.split(",")[0] : "Undecided"}`}
                              </p>
                            </div>
                            <div className="col-2">
                              <p className=" fs-11 text-A7A7A7 mb-1">Vehicle</p>
                              <p className="m-0 fs-14 text-4E4E4E">
                                {item?.bookingItems
                                  .filter((item) => item.type === "vehicle")
                                  .reduce((acc, v) => {
                                    const existingItem = acc.find(
                                      (i) => i.name === v.name
                                    );

                                    if (existingItem) {
                                      // Jika ada, jumlahkan qty
                                      existingItem.qty += v.qty;
                                    } else {
                                      acc.push({ name: v.name, qty: v.qty });
                                    }
                                    return acc;
                                  }, [])
                                  .map((v) => (
                                    <>
                                      {v.name} x{v.qty}{"\n"}
                                    </>
                                  ))}
                              </p>
                            </div>
                            <div className="col-4">
                              <div className="d-flex justify-content-end align-items-center gap-1 mt-2">
                                <button
                                  className="btn btn-outline-default rounded"
                                  onClick={() => openModalDetailTransfer(item)}
                                >
                                  <div className="tw:flex tw:!justify-center tw:!items-center">
                                    <EyeGoldIcon
                                      className="me-2"
                                      color="#DBBE78"
                                    />
                                    <p className="m-0">Details</p>
                                  </div>
                                </button>
                                {isPaymentLocked ? (
                                  <button
                                    className="btn btn-outline-default rounded"
                                    onClick={() =>
                                      window.open(
                                        `/admin/bookinglist/edit/v2/${item._id}`,
                                        "_blank",
                                        "noopener,noreferrer"
                                      )
                                    }
                                  >
                                    <div className="tw:flex tw:!justify-center tw:!items-center">
                                      <ArrowOutwardIcon className="me-2" color="#DBBE78" />
                                      <p className="m-0">Booking Detail</p>
                                    </div>
                                  </button>
                                ) : !isDisableEdit && (
                                  <>
                                    <button
                                      className="btn btn-outline-default  rounded"
                                      onClick={() =>
                                        handleNavigateToEditTransfer(item)
                                      }
                                    >
                                      <div className="d-flex">
                                        <EditIcon
                                          className="me-2"
                                        />
                                        <p className="m-0">Edit </p>
                                      </div>
                                    </button>
                                    <button
                                      className="btn btn-outline-default  rounded"
                                      onClick={() => openModalDuplicate(item._id)}
                                    >
                                      <div className="d-flex">
                                        <CopyIcon
                                          className="me-2"
                                        />
                                        <p className="m-0">Duplicate</p>
                                      </div>
                                    </button>
                                    <button
                                      className="btn btn-danger rounded p-0"
                                      style={{ width: "36px", height: "36px" }}
                                      onClick={() =>
                                        openModalDeleteTransferConfirmation(item._id)
                                      }
                                    // handleDeleteTransfer(quotationId, item._id)
                                    >
                                      <img
                                        src={trash_icon}
                                        alt=""
                                        srcSet=""
                                        className=""
                                        style={{ width: "21px", height: "21px" }}
                                      />
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                      {!isDisableEdit && (
                        <div className="border-dashsed rounded p-5 mt-3">
                          <div className="d-flex justify-content-center">
                            <button
                              className="btn"
                              onClick={handleNavigateToTransfer}
                            >
                              <div className="d-flex align-items-center">
                                <AddAltIcon
                                  color="#DBBE78"
                                  className="me-2"
                                />
                                <p className="fs-14 m-0">Add Transfer</p>
                              </div>
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion mb-4" id="quotatItems">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="quotatItemsLabel">
                    <button
                      className="accordion-button with-arrow-2 bg-white px-3"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#quotatItemsItem"
                      aria-expanded="true"
                      aria-controls="quotatItemsItem"
                    >
                      Quotation Items
                    </button>
                  </h2>
                  {/* Locked quotation: hide the discount config, just say whether the bookings use a discount */}
                  {quotationDetail?.bookings?.length > 0 && isDisableEdit && (() => {
                    const discountedRates = [...new Set(
                      (quotationDetail?.bookings || [])
                        .filter((b) => b?.useDiscount && Number(b?.discount) > 0)
                        .map((b) => Number(b.discount))
                    )];
                    const hasDiscount = quotationDetail?.useDiscount && discountedRates.length > 0;
                    const rateLabel = discountedRates.length === 1
                      ? `${discountedRates[0]}% per transfer`
                      : `${Math.min(...discountedRates)}%–${Math.max(...discountedRates)}% per transfer`;

                    return (
                      <div className="row px-3 my-3">
                        <div className="col-12">
                          <div className="rounded border-gold-100 p-3">
                            {hasDiscount ? (
                              <p className="m-0 fs-14 text-4E4E4E">
                                <span className="fw-bold">Discount applied</span>
                                {` — ${rateLabel}`}
                                {Number(quotationDetail?.totalDiscount) > 0 &&
                                  ` (total -${Number(quotationDetail.totalDiscount).toLocaleString()} JPY)`}
                                . The prices below are the discounted prices.
                              </p>
                            ) : (
                              <p className="m-0 fs-14 text-4E4E4E">
                                <span className="fw-bold">No discount</span>
                                {" — the bookings in this quotation use the original prices."}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })()}
                  {/* Discount toggles — only relevant when transfers exist */}
                  {quotationDetail?.bookings?.length > 0 && !isDisableEdit && <div className={`row px-3 align-items-stretch ${showDiscounted ? 'mt-3 mb-3' : 'my-3'}`}>
                    <div className="col-12 col-md-3 mt-2 mt-md-0">
                      <div
                        className={`rounded h-100 ${isDisableEdit ? 'tw:!cursor-not-allowed tw:!opacity-60' : 'click-pointer'} ${showDiscounted ? 'border-gold-100' : 'border-gold'}`}
                        onClick={() => { if (isDisableEdit) return; resetDiscount(); }}
                      >
                        <div className="d-flex p-3 justify-content-start align-items-center h-100">
                          <div className="col-auto">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="priceView"
                              id="originalPrice"
                              value="original"
                              checked={!showDiscounted}
                              onChange={() => resetDiscount()}
                              disabled={isDisableEdit}
                            />
                          </div>
                          <div className="col">
                            <label
                              className="ms-3 ms-md-2 click-pointer"
                              htmlFor="originalPrice"
                              style={{
                                fontWeight: !showDiscounted ? "700" : "400",
                              }}
                            >
                              Show original price
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 mt-2 mt-md-0">
                      <div
                        className={`rounded h-100 ${isDisableEdit ? 'tw:!cursor-not-allowed tw:!opacity-60' : 'click-pointer'} ${!showDiscounted ? 'border-gold-100' : 'border-gold'}`}
                        onClick={() => { if (isDisableEdit) return; enableDiscountView(); }}
                      >
                        <div className="d-flex p-3 justify-content-start align-items-center h-100">
                          <div className="col-auto">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="priceView"
                              id="discountedPrice"
                              value="discounted"
                              checked={showDiscounted}
                              onChange={() => enableDiscountView()}
                              disabled={isDisableEdit}
                            />
                          </div>
                          <div className="col">
                            <label
                              className="ms-3 ms-md-2 click-pointer"
                              htmlFor="discountedPrice"
                              style={{
                                fontWeight: showDiscounted ? "700" : "400",
                              }}
                            >
                              Show discounted price
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    {showDiscounted && (
                      <div className="col-12 col-md-auto mt-2 mt-md-0 d-flex align-items-stretch">
                        <div className="tw:flex tw:items-stretch tw:border tw:border-solid tw:border-[#DADADA] tw:rounded tw:h-full tw:overflow-hidden" style={{ width: "auto" }}>
                          <span className="tw:px-3 tw:flex tw:items-center tw:bg-white tw:text-[#6c757d] tw:text-[14px] tw:whitespace-nowrap">Rate</span>
                          <input
                            type="number"
                            className="tw:!border-0 tw:!rounded-none tw:!bg-white tw:!px-2 tw:focus:!outline-none tw:focus:!ring-0 tw:focus:!shadow-none"
                            placeholder="0"
                            min={0}
                            max={100}
                            onChange={(e) => handleChangeDiscountRate(e)}
                            onWheel={(e) => e.target.blur()}
                            value={discount === 0 ? "" : discount}
                            style={{ width: "60px", minWidth: "60px" }}
                            disabled={isDisableEdit}
                          />
                          <span className="tw:px-3 tw:flex tw:items-center tw:bg-white">%</span>
                          <button
                            className="btn btn-primary tw:!text-[#FFFFFF] tw:!rounded-none tw:!rounded-r px-3 tw:whitespace-nowrap"
                            onClick={() => applyDiscountHandler()}
                            disabled={
                              !quotationDetail ||
                              quotationDetail?.bookings?.length == 0 ||
                              isDisableEdit
                            }
                          >
                            Apply to all
                          </button>
                        </div>
                      </div>
                    )}
                    {showDiscounted && (
                      <div className="col-12 mt-2">
                        <p className="tw:text-[12px]! text-7C7B7B mb-0">
                          Set a discount rate per transfer below, or use "Apply to all" to set the same rate on every transfer.
                        </p>
                      </div>
                    )}
                  </div>}
                  <div
                    id="quotatItemsItem"
                    className="accordion-collapse collapse show"
                    aria-labelledby="quotatItemsLabel"
                    data-bs-parent="#quotatItems"
                  >
                    <table className="table table-quotation-items p-4">

                      <tr className="bg-dark">
                        <th className="align-middle py-2" style={{ width: "20%", whiteSpace: "nowrap" }}>
                          <p className="py-0 ms-2 text-white mb-0">Service Date</p>
                        </th>
                        <th className="align-middle py-2" style={{ width: "40%" }}>
                          <b className="pb-0 ms-2">Name</b>
                          <p className="py-0 ms-2 text-white mb-0">Description</p>
                        </th>
                        <th className="align-middle py-2" style={{ width: "15%", whiteSpace: "nowrap" }}>
                          <p className="py-0 ms-2 text-white mb-0">Unit Price</p>
                        </th>
                        <th className="align-middle py-2" style={{ width: "10%", whiteSpace: "nowrap" }}>
                          <p className="py-0 ms-2 text-white mb-0">Qty</p>
                        </th>
                        <th className="align-middle py-2" style={{ whiteSpace: "nowrap", width: "1%" }}>
                          <p className="py-0 ms-2 text-white mb-0">Amount</p>
                        </th>
                        <th className="align-middle py-2"></th>
                      </tr>
                      <>
                        {quotationDetail?.bookings?.map((item, index) => (
                          <>
                            {/* Booking Type Row */}
                            <tr className="tw:!bg-[#7C7B7B]">
                              <td colSpan={6}>
                                <div className="d-flex align-items-center justify-content-between gap-2">
                                  <p className="m-0 tw:!text-[#FFFFFF] tw:!text-[14px] tw:!font-[400]">
                                    {getBookingType(
                                      item?.bookingType,
                                      item?.isAirportTransfer
                                    )}
                                  </p>
                                  {showDiscounted && !isDisableEdit && (
                                    <div className="tw:flex tw:items-stretch tw:border tw:border-solid tw:border-[#DADADA] tw:rounded tw:overflow-hidden">
                                      <span className="tw:px-2 tw:flex tw:items-center tw:bg-white tw:text-[#6c757d] tw:text-[13px] tw:whitespace-nowrap">Rate</span>
                                      <input
                                        type="number"
                                        className="tw:!border-0 tw:!rounded-none tw:!bg-white tw:!px-2 tw:!py-1 tw:!text-[13px] tw:focus:!outline-none tw:focus:!ring-0 tw:focus:!shadow-none"
                                        placeholder="0"
                                        min={0}
                                        max={100}
                                        onChange={(e) => handleChangeBookingDiscountRate(item._id, e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                        onClick={(e) => e.stopPropagation()}
                                        value={bookingDiscounts[String(item._id)] ? bookingDiscounts[String(item._id)] : ""}
                                        style={{ width: "56px", minWidth: "56px" }}
                                      />
                                      <span className="tw:px-2 tw:flex tw:items-center tw:bg-white tw:text-[13px]">%</span>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>

                            {/* Booking Items */}
                            {item?.bookingItems?.map((b, index) => (
                              <>
                                <tr
                                  key={index}
                                  className={`${index !== 0 ? 'border-top' : ''}`}
                                >
                                  <td><p className="py-0 mb-0 tw:!text-[#4E4E4E] tw:!text-[14px]">{b?.serviceDate}</p></td>
                                  <td>
                                    <p className="tw:!text-[#4E4E4E] tw:!font-[700] tw:!text-[14px] tw:!py-0 tw:!mb-0">{b?.name}</p>
                                    <p className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px] tw:!py-0 tw:!mb-0">{b?.desc}</p>
                                  </td>
                                  <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]" style={{ whiteSpace: "nowrap" }}>{`${b?.price?.toLocaleString()} JPY`}</td>
                                  <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{b?.qty}</td>
                                  <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]" style={{ whiteSpace: "nowrap" }}>{`${b?.totalPrice?.toLocaleString()} JPY`}</td>
                                  <td></td>
                                </tr>

                                {b.type === "vehicle" && (
                                  [...Array(bookingItemsDetailOrder?.length)].map((x, i) => (
                                    b?.totalDiscount != null ? (
                                      bookingItemsDetailOrder[i] === "discount" ? (
                                        <tr className="bg-F5F5F5">
                                          <td colSpan={4}>
                                            <p className="px-4 py-0 mb-0 text-description text-end">{`DISCOUNT (${b?.discount}%)`}</p>
                                          </td>
                                          <td className="text-description py-0 my-0 tw:!whitespace-nowrap">
                                            {`-${b?.totalDiscount?.toLocaleString()} JPY`}
                                          </td>
                                          <td></td>
                                        </tr>
                                      ) : (
                                        b?.details?.find(item => item.id === bookingItemsDetailOrder[i])?.amount > 0 && (
                                          <tr
                                            key={i}
                                            className={`border-top-dashed`}
                                          >
                                            <td></td>
                                            <td><p className="px-4 py-0 mb-0 text-description tw:!text-[#4E4E4E]">{b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).name}</p></td>
                                            <td></td>
                                            <td></td>
                                            <td className="text-description tw:!text-[#4E4E4E] tw:!whitespace-nowrap">{`${b?.details?.find(item => item.id === bookingItemsDetailOrder[i])?.amount?.toLocaleString()} JPY`}</td>
                                            <td></td>
                                          </tr>
                                        )
                                      )
                                    ) : (
                                      (bookingItemsDetailOrder[i] !== "discount" && b?.details?.find(item => item.id === bookingItemsDetailOrder[i])?.amount > 0) && (
                                        <tr
                                          key={i}
                                          className={`border-top-dashed`}
                                        >
                                          <td></td>
                                          <td><p className="px-4 py-0 mb-0 text-description tw:!text-[#4E4E4E]">{b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).name}</p></td>
                                          <td></td>
                                          <td></td>
                                          <td className="text-description tw:!text-[#4E4E4E] tw:!whitespace-nowrap">{`${b?.details?.find(item => item.id === bookingItemsDetailOrder[i])?.amount?.toLocaleString()} JPY`}</td>
                                        </tr>
                                      )
                                    )
                                  ))
                                )}
                              </>
                            ))}

                            {getAdditionalGroups(item).map((group, groupIndex) => (
                              <React.Fragment key={`group-${groupIndex}`}>
                                {group.heading ? (
                                  <tr className={`border-top tw:!bg-[#F1F1F1]`}>
                                    <td colSpan={6}>
                                      <p className="m-0 py-0 tw:!text-[#212529]">{group.heading}</p>
                                    </td>
                                  </tr>
                                ) : null}
                                {(group.items || []).map((additionalItem, additionalIndex) => {
                                  const itemName = additionalItem?.name || "-";
                                  const additionalItemServiceDate = additionalItem?.serviceDate ? moment(additionalItem.serviceDate).locale("en").format("MMMM D, YYYY") : "";
                                  const isFirstRow = !group.heading && additionalIndex === 0;
                                  return (
                                    <tr className={isFirstRow ? "border-top" : "border-top-dashed"} key={`additional-${groupIndex}-${additionalIndex}`}>
                                      <td><p className="py-0 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{additionalItemServiceDate}</p></td>
                                      <td><p className="py-0 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{itemName}</p></td>
                                      <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px] tw:!whitespace-nowrap">{`${Number(additionalItem?.price || 0).toLocaleString()} JPY`}</td>
                                      <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{additionalItem?.qty || ""}</td>
                                      <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px] tw:!whitespace-nowrap">{`${Number(additionalItem?.totalPrice || 0).toLocaleString()} JPY`}</td>
                                      <td className="tw:!align-middle">
                                        {(additionalIndex === 0 && !isDisableEdit) && (
                                          <button
                                            className="btn p-0 d-flex align-items-center justify-content-center rounded-1 lh-1 tw:!w-8 tw:!h-8 tw:!bg-[#F9EDD3]"
                                            onClick={() => openInlineEditGroup(index, groupIndex)}
                                          >
                                            <EditPenIcon color="#B28A29" size={14} />
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </React.Fragment>
                            ))}

                            {/* Subtotal */}
                            <tr className="bg-DADADA">
                              <td colSpan={4} >
                                <div className="d-flex justify-content-end align-items-center px-4">
                                  <span>SUBTOTAL</span>
                                </div>
                              </td>
                              <td >
                                <div className="d-flex justify-content-start align-items-center p-0">
                                  <b className="m-0 p-0 text-nowrap">
                                    {item?.bookingItems
                                      ? `${(
                                        (item?.bookingItems || []).reduce(
                                          (subtotal, b) => subtotal + (b.discountedPrice ? b.discountedPrice : b.totalPrice),
                                          0
                                        ) +
                                        getAllAdditionalItems(item).reduce(
                                          (subtotal, additionalItem) => subtotal + Number(additionalItem?.totalPrice || 0),
                                          0
                                        )
                                      ).toLocaleString()} JPY`
                                      : `0 JPY`}
                                  </b>
                                </div>
                              </td>
                              <td></td>
                            </tr>

                            {/* Notes */}
                            {checkNotes(item).available && (
                              <tr className="tw:!bg-[#F9F9F9]">
                                <td><p className="py-2 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">Transfer Notes</p></td>
                                <td colSpan={5}><p className="py-2 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{checkNotes(item).note}</p></td>
                              </tr>
                            )}

                            {!((inlineAddItemVisible && selectedBookingIndex === index) || isDisableEdit) && (
                              <tr>
                                <td colSpan={6} className="tw:!p-0 tw:bg-[#E2C47C]">
                                  <div className="tw:p-0">
                                    <button
                                      className="tw:w-full tw:flex tw:items-center tw:justify-center"
                                      onClick={() => openInlineAddItem(index)}
                                    >
                                      <div className="tw:flex tw:items-center tw:justify-center tw:gap-x-2 tw:bg-[#E2C47C]">
                                        <BsPlusCircle color="white" size={16} />
                                        <span className="tw:text-white tw:font-bold">Add Item</span>
                                      </div>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            )}

                            {inlineAddItemVisible && selectedBookingIndex === index && (
                              <>
                                <tr style={{ backgroundColor: isEditingItems ? '#F9EDD3' : '#8D8D8D' }}>
                                  <td className="text-center pe-2" colSpan={6}>
                                    <span style={{ color: isEditingItems ? '#B28A29' : '#FFFFFF' }} className="tw:!italic tw:!text-[14px]/[10px] tw:!font-[400] tw:!m-0 tw:!p-0">
                                      {isEditingItems ? 'Editing Item' : 'Adding Item'}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={6} className="tw:!p-0">
                                    <div className="p-3 border border-top-0 tw:bg-white quotation-item-form-enter">
                                      <div className="d-flex flex-column" style={{ gap: "16px" }}>
                                        <div className="pt-1 border-bottom">
                                          <label className="tw:!text-[#282828] tw:!text-[16px] tw:!font-[500] tw:!mb-3">
                                            {isEditingItems ? 'Editing Quotation Item' : 'Add Quotation Item'}
                                          </label>
                                        </div>

                                        <div className="pt-1">
                                          <label className="mb-2 fs-14">Heading</label>
                                          <AdminInput
                                            placeholder="Input Heading"
                                            value={manualGroup.heading}
                                            onChange={(e) => handleManualGroupHeadingChange(e.target.value)}
                                            name="manualItemHeading"
                                            mb="mb-0"
                                          />
                                        </div>

                                        {manualGroup.items.map((manualItem, manualItemIndex) => (
                                          <div key={`manual-item-${manualItemIndex}`} className="row g-2 align-items-end">
                                            <div className="col-12 col-lg-2">
                                              <label className="mb-2 fs-14">Service Date</label>
                                              <AdminInputDatePicker
                                                placeholder="Select date"
                                                suffixIcon={<CalendarAltIcon />}
                                                iconSize={16}
                                                mb={""}
                                                hasIndex={true}
                                                index={manualItemIndex}
                                                onSelectDate={handleManualItemServiceDateChange}
                                                value={manualItem.serviceDate ? moment(manualItem.serviceDate, "YYYY-MM-DD").toDate() : null}
                                                dateFormat="MMMM d, yyyy"
                                                inputClassName="tw:!text-[15px]"
                                              />
                                            </div>

                                            <div className="col-12 col-lg-5">
                                              <label className="mb-2 fs-14">Item Name/Description <span className="text-danger">*</span></label>
                                              <AdminInput
                                                placeholder="Input description"
                                                value={manualItem.itemDescription}
                                                onChange={(e) => handleManualItemFieldChange(manualItemIndex, "itemDescription", e.target.value)}
                                                name="itemDescription"
                                                mb="mb-0"
                                                inputClassName="tw:!text-[15px]"
                                              />
                                            </div>

                                            <div className="col-12 col-lg-2">
                                              <label className="mb-2 fs-14">Unit Price <span className="text-danger">*</span></label>
                                              <div className="tw:relative">
                                                <AdminInput
                                                  placeholder="0"
                                                  value={manualItem.unitPrice}
                                                  onChange={(e) => handleManualItemFieldChange(manualItemIndex, "unitPrice", e.target.value)}
                                                  name="unitPrice"
                                                  mb="mb-0"
                                                  inputClassName="tw:!text-[15px]"
                                                />
                                                <span className="tw:text-[12px]! text-7C7B7B tw:absolute tw:right-3 tw:top-1/2 tw:-translate-y-1/2 tw:pointer-events-none">JPY</span>
                                              </div>
                                            </div>

                                            <div className="col-12 col-lg-1">
                                              <label className="mb-2 fs-14">Qty</label>
                                              <AdminInput
                                                value={manualItem.qty}
                                                onChange={(e) => handleManualItemFieldChange(manualItemIndex, "qty", e.target.value)}
                                                name="qty"
                                                mb="mb-0"
                                                inputClassName="tw:!text-[15px]"
                                              />
                                            </div>

                                            <div className="col-12 col-lg-2">
                                              <label className="mb-2 fs-14">Amount</label>
                                              <div className="d-flex align-items-center gap-2">
                                                <div className="tw:relative flex-grow-1">
                                                  <AdminInput
                                                    placeholder="1"
                                                    value={getManualItemAmount(manualItem).toLocaleString()}
                                                    name="amount"
                                                    mb="mb-0"
                                                    disabled={true}
                                                    readOnly={true}
                                                    inputClassName="tw:!text-[15px]"
                                                  />
                                                  <span className="tw:text-[12px]! text-7C7B7B tw:absolute tw:right-3 tw:top-1/2 tw:-translate-y-1/2 tw:pointer-events-none">JPY</span>
                                                </div>
                                                <button
                                                  className="btn p-0 flex-shrink-0"
                                                  onClick={() => removeManualQuotationItemRow(manualItemIndex)}
                                                  disabled={manualGroup.items.length === 1}
                                                >
                                                  <BsX size={36} color={manualGroup.items.length === 1 ? "#CFCFCF" : "#EA4335"} />
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        ))}

                                        <button
                                          className="btn w-100 bg-white tw:!border tw:!border-dashed tw:!border-[#E0E0E0] tw:!text-[#777777]"
                                          onClick={addManualQuotationItemRow}
                                        >
                                          <span className="d-flex align-items-center justify-content-center gap-2">
                                            <BsPlusCircle color="#D2AF61" size={14} />
                                            Add Item
                                          </span>
                                        </button>

                                        <div className="d-flex align-items-center justify-content-between gap-3 mt-1">
                                          <div className={`d-flex gap-3 ${isEditingItems ? '' : 'w-100 justify-content-center'}`}>
                                            <button
                                              className="btn rounded"
                                              style={{ width: "240px", backgroundColor: "#F2F2F2", color: "#4A4A4A" }}
                                              onClick={closeInlineAddItem}
                                            >
                                              Discard
                                            </button>
                                            <button
                                              className="btn rounded"
                                              style={{ width: "240px", backgroundColor: "#D2AF61" }}
                                              onClick={submitManualQuotationItems}
                                              disabled={savingInlineAddItem}
                                            >
                                              <span className="tw:text-white">
                                                {savingInlineAddItem ? "Saving..." : "Save"}
                                              </span>
                                            </button>
                                          </div>
                                          {isEditingItems && (
                                            <button
                                              className="btn rounded d-flex align-items-center gap-2 tw:!bg-[#FDEDEB] tw:!text-[#EA4335] tw:!border-0 px-4"
                                              onClick={() => setConfirmRemoveAllVisible(true)}
                                            >
                                              <BsX size={18} color="#EA4335" />
                                              Remove All
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            )}
                          </>
                        ))}

                        {/* Standalone Additional Items section */}
                        <>
                          <tr className="tw:!bg-[#7C7B7B]">
                            <td colSpan={6}>
                              <p className="m-0 tw:!text-[#FFFFFF] tw:!text-[14px] tw:!font-[400]">Additional Items</p>
                            </td>
                          </tr>

                          {effectiveStandaloneGroups.map((group, groupIndex) => (
                            <React.Fragment key={`standalone-group-${groupIndex}`}>
                              {group.heading ? (
                                <tr className={`border-top tw:!bg-[#F1F1F1]`}>
                                  <td colSpan={6}>
                                    <p className="m-0 py-0 tw:!text-[#212529]">{group.heading}</p>
                                  </td>
                                </tr>
                              ) : null}
                              {(group.items || []).map((additionalItem, additionalIndex) => {
                                const itemName = additionalItem?.name || "-";
                                const itemServiceDate = additionalItem?.serviceDate ? moment(additionalItem.serviceDate).locale("en").format("MMMM D, YYYY") : "";
                                const isFirstRow = !group.heading && additionalIndex === 0;
                                return (
                                  <tr className={isFirstRow ? "border-top" : "border-top-dashed"} key={`standalone-${groupIndex}-${additionalIndex}`}>
                                    <td><p className="py-0 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{itemServiceDate}</p></td>
                                    <td><p className="py-0 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{itemName}</p></td>
                                    <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px] tw:!whitespace-nowrap">{`${Number(additionalItem?.price || 0).toLocaleString()} JPY`}</td>
                                    <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{additionalItem?.qty || ""}</td>
                                    <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px] tw:!whitespace-nowrap">{`${Number(additionalItem?.totalPrice || 0).toLocaleString()} JPY`}</td>
                                    <td className="tw:!align-middle">
                                      {(additionalIndex === 0 && !isDisableEdit) && (
                                        <button
                                          className="btn p-0 d-flex align-items-center justify-content-center rounded-1 lh-1 tw:!w-8 tw:!h-8 tw:!bg-[#F9EDD3]"
                                          onClick={() => openStandaloneEditGroup(groupIndex)}
                                        >
                                          <EditPenIcon color="#B28A29" size={14} />
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </React.Fragment>
                          ))}

                          {effectiveStandaloneGroups.length > 0 && (
                            <tr className="bg-DADADA">
                              <td colSpan={4}>
                                <div className="d-flex justify-content-end align-items-center px-4">
                                  <span>SUBTOTAL</span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex justify-content-start align-items-center p-0">
                                  <b className="m-0 p-0 text-nowrap">
                                    {`${computeStandaloneItemsTotal(effectiveStandaloneGroups).toLocaleString()} JPY`}
                                  </b>
                                </div>
                              </td>
                              <td></td>
                            </tr>
                          )}

                          {!standaloneAddItemVisible && !isDisableEdit && (
                            <tr>
                              <td colSpan={6} className="tw:!px-4 tw:!py-3">
                                <button
                                  className="tw:w-full tw:flex tw:items-center tw:justify-center tw:gap-x-2 tw:border-2 tw:border-dashed tw:border-[#D2AF61] tw:rounded tw:py-3 tw:bg-[#FFF8E8] tw:transition-colors hover:tw:bg-[#FFF0CC]"
                                  onClick={openStandaloneAddItem}
                                >
                                  <BsPlusCircle color="#D2AF61" size={18} />
                                  <span className="tw:text-[#D2AF61] tw:font-bold tw:text-[15px]">Add Additional Item</span>
                                </button>
                              </td>
                            </tr>
                          )}

                          {standaloneAddItemVisible && (
                            <>
                              <tr style={{ backgroundColor: isEditingStandaloneItems ? '#F9EDD3' : '#8D8D8D' }}>
                                <td className="text-center pe-2" colSpan={6}>
                                  <span style={{ color: isEditingStandaloneItems ? '#B28A29' : '#FFFFFF' }} className="tw:!italic tw:!text-[14px]/[10px] tw:!font-[400] tw:!m-0 tw:!p-0">
                                    {isEditingStandaloneItems ? 'Editing Item' : 'Adding Item'}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td colSpan={6} className="tw:!p-0">
                                  <div className="p-3 border border-top-0 tw:bg-white quotation-item-form-enter">
                                    <div className="d-flex flex-column" style={{ gap: "16px" }}>
                                      <div className="pt-1 border-bottom">
                                        <label className="tw:!text-[#282828] tw:!text-[16px] tw:!font-[500] tw:!mb-3">
                                          {isEditingStandaloneItems ? 'Editing Additional Item' : 'Add Additional Item'}
                                        </label>
                                      </div>

                                      <div className="pt-1">
                                        <label className="mb-2 fs-14">Heading</label>
                                        <AdminInput
                                          placeholder="Input Heading"
                                          value={standaloneManualGroup.heading}
                                          onChange={(e) => handleStandaloneGroupHeadingChange(e.target.value)}
                                          name="standaloneItemHeading"
                                          mb="mb-0"
                                        />
                                      </div>

                                      {standaloneManualGroup.items.map((manualItem, manualItemIndex) => (
                                        <div key={`standalone-manual-item-${manualItemIndex}`} className="row g-2 align-items-end">
                                          <div className="col-12 col-lg-2">
                                            <label className="mb-2 fs-14">Service Date</label>
                                            <AdminInputDatePicker
                                              placeholder="Select date"
                                              suffixIcon={<CalendarAltIcon />}
                                              iconSize={16}
                                              mb={""}
                                              hasIndex={true}
                                              index={manualItemIndex}
                                              onSelectDate={handleStandaloneItemServiceDateChange}
                                              value={manualItem.serviceDate ? moment(manualItem.serviceDate, "YYYY-MM-DD").toDate() : null}
                                              dateFormat="MMMM d, yyyy"
                                              inputClassName="tw:!text-[15px]"
                                            />
                                          </div>

                                          <div className="col-12 col-lg-5">
                                            <label className="mb-2 fs-14">Item Name/Description <span className="text-danger">*</span></label>
                                            <AdminInput
                                              placeholder="Input description"
                                              value={manualItem.itemDescription}
                                              onChange={(e) => handleStandaloneItemFieldChange(manualItemIndex, "itemDescription", e.target.value)}
                                              name="standaloneItemDescription"
                                              mb="mb-0"
                                              inputClassName="tw:!text-[15px]"
                                            />
                                          </div>

                                          <div className="col-12 col-lg-2">
                                            <label className="mb-2 fs-14">Unit Price <span className="text-danger">*</span></label>
                                            <div className="tw:relative">
                                              <AdminInput
                                                placeholder="0"
                                                value={manualItem.unitPrice}
                                                onChange={(e) => handleStandaloneItemFieldChange(manualItemIndex, "unitPrice", e.target.value)}
                                                name="standaloneUnitPrice"
                                                mb="mb-0"
                                                inputClassName="tw:!text-[15px]"
                                              />
                                              <span className="tw:text-[12px]! text-7C7B7B tw:absolute tw:right-3 tw:top-1/2 tw:-translate-y-1/2 tw:pointer-events-none">JPY</span>
                                            </div>
                                          </div>

                                          <div className="col-12 col-lg-1">
                                            <label className="mb-2 fs-14">Qty</label>
                                            <AdminInput
                                              value={manualItem.qty}
                                              onChange={(e) => handleStandaloneItemFieldChange(manualItemIndex, "qty", e.target.value)}
                                              name="standaloneQty"
                                              mb="mb-0"
                                              inputClassName="tw:!text-[15px]"
                                            />
                                          </div>

                                          <div className="col-12 col-lg-2">
                                            <label className="mb-2 fs-14">Amount</label>
                                            <div className="d-flex align-items-center gap-2">
                                              <div className="tw:relative flex-grow-1">
                                                <AdminInput
                                                  placeholder="1"
                                                  value={getManualItemAmount(manualItem).toLocaleString()}
                                                  name="standaloneAmount"
                                                  mb="mb-0"
                                                  disabled={true}
                                                  readOnly={true}
                                                  inputClassName="tw:!text-[15px]"
                                                />
                                                <span className="tw:text-[12px]! text-7C7B7B tw:absolute tw:right-3 tw:top-1/2 tw:-translate-y-1/2 tw:pointer-events-none">JPY</span>
                                              </div>
                                              <button
                                                className="btn p-0 flex-shrink-0"
                                                onClick={() => removeStandaloneItemRow(manualItemIndex)}
                                                disabled={standaloneManualGroup.items.length === 1}
                                              >
                                                <BsX size={36} color={standaloneManualGroup.items.length === 1 ? "#CFCFCF" : "#EA4335"} />
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      ))}

                                      <button
                                        className="btn w-100 bg-white tw:!border tw:!border-dashed tw:!border-[#E0E0E0] tw:!text-[#777777]"
                                        onClick={addStandaloneItemRow}
                                      >
                                        <span className="d-flex align-items-center justify-content-center gap-2">
                                          <BsPlusCircle color="#D2AF61" size={14} />
                                          Add Item
                                        </span>
                                      </button>

                                      <div className="d-flex align-items-center justify-content-between gap-3 mt-1">
                                        <div className={`d-flex gap-3 ${isEditingStandaloneItems ? '' : 'w-100 justify-content-center'}`}>
                                          <button
                                            className="btn rounded"
                                            style={{ width: "240px", backgroundColor: "#F2F2F2", color: "#4A4A4A" }}
                                            onClick={closeStandaloneAddItem}
                                          >
                                            Discard
                                          </button>
                                          <button
                                            className="btn rounded"
                                            style={{ width: "240px", backgroundColor: "#D2AF61" }}
                                            onClick={submitStandaloneItems}
                                            disabled={savingStandaloneItem}
                                          >
                                            <span className="tw:text-white">
                                              {savingStandaloneItem ? "Saving..." : "Save"}
                                            </span>
                                          </button>
                                        </div>
                                        {isEditingStandaloneItems && (
                                          <button
                                            className="btn rounded d-flex align-items-center gap-2 tw:!bg-[#FDEDEB] tw:!text-[#EA4335] tw:!border-0 px-4"
                                            onClick={() => setConfirmRemoveStandaloneVisible(true)}
                                          >
                                            <BsX size={18} color="#EA4335" />
                                            Remove All
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </>
                          )}
                        </>

                        {/* Total */}
                        <tr className="bg-dark text-white">
                          <td colSpan={4} >
                            <div className="d-flex justify-content-end align-items-center px-4 py-0">
                              <p className="py-0 my-0 text-white tw:text-[12px]!">
                                <b className="fs-16">TOTAL AMOUNT</b> {" "}
                                (Tax Incl.)
                              </p>
                            </div>
                          </td>
                          <td className="no-wrap">
                            <div className="d-flex justify-content-start align-items-center p-0">
                              <b className="m-0 p-0 fs-18 text-nowrap">
                                {`${computedTotalAmount.toLocaleString()} JPY`}
                              </b>
                            </div>
                          </td>
                          <td></td>
                        </tr>
                      </>
                    </table>
                  </div>
                </div>
              </div>

              {separatelyChargedBookings.length > 0 && (
                <div
                  className="tw:mb-4 tw:rounded tw:border tw:border-[#D2AF61] tw:bg-[#FDF8EE] tw:p-4"
                  data-testid="separately-charged-banner"
                >
                  <p className="tw:mb-2 tw:font-semibold tw:text-[#8A6D1F]">
                    {separatelyChargedBookings.length === 1
                      ? "1 booking on this quotation was already charged separately"
                      : `${separatelyChargedBookings.length} bookings on this quotation were already charged separately`}
                  </p>
                  <p className="tw:mb-2 tw:text-[13px] tw:text-[#5C4A17]">
                    These were charged when an admin edited them, so they are excluded from
                    this quotation's charge.
                  </p>
                  <ul className="tw:mb-3 tw:list-disc tw:pl-5 tw:text-[13px] tw:text-[#5C4A17]">
                    {separatelyChargedBookings.map((item) => {
                      const charged = Number(item.chargedSeparatelyAmount || 0);
                      const deducted = Number(
                        item.quotationDeductionAmount ?? item.chargedSeparatelyAmount ?? 0
                      );

                      return (
                        <li key={item._id}>
                          {`Booking #${item.key}`}
                          {item.passengerName ? ` — ${item.passengerName}` : ""}
                          {` — charged ${charged.toLocaleString()} JPY`}
                          {charged !== deducted
                            ? ` (${deducted.toLocaleString()} JPY deducted from this quotation)`
                            : ""}
                        </li>
                      );
                    })}
                  </ul>
                  <div className="tw:flex tw:justify-between tw:border-t tw:border-[#E4D4A8] tw:pt-2 tw:text-[13px] tw:text-[#5C4A17]">
                    <span>Deducted from this quotation</span>
                    <b>{`${separatelyChargedTotal.toLocaleString()} JPY`}</b>
                  </div>
                  <div className="tw:flex tw:justify-between tw:text-[13px] tw:text-[#5C4A17]">
                    <span>Remaining to charge on this quotation</span>
                    <b>{`${remainingChargeAmount.toLocaleString()} JPY`}</b>
                  </div>
                </div>
              )}

              <div className="accordion mb-4" id="quotationNotes">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="quotationNotesLabel">
                    <button
                      className="accordion-button with-arrow-2 bg-white px-3"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#quotationNotesItem"
                      aria-expanded="true"
                      aria-controls="quotationNotesItem"
                    >
                      Notes
                    </button>
                  </h2>
                  <div
                    id="quotationNotesItem"
                    className="accordion-collapse collapse show"
                    aria-labelledby="quotationNotesLabel"
                    data-bs-parent="#quotationNotes"
                  >
                    <div className="p-3">
                      <AdminTextArea
                        value={notes}
                        placeholder={"Itinerary details or additional notes"}
                        onChange={(e) => handleNotes(e.target.value)}
                        disabled={isDisableEdit}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {(quotationId || localStandaloneGroups.length > 0) && !isDisableEdit && (
                <div className="d-grid">
                  <button
                    className="btn btn-primary py-2 tw:!text-white tw:!rounded"
                    onClick={openModalSubmitConfirmation}
                  >
                    Save
                  </button>
                </div>
              )}
              {quotationDetail &&
                quotationDetail.paymentStatus === "READY_TO_CHARGE" && (
                  <div className="tw:fixed tw:bottom-6 tw:right-6 tw:z-50">
                    <button
                      className="btn rounded tw:!px-8 tw:!py-2 tw:shadow-lg tw:min-w-[320px]"
                      style={{ backgroundColor: "#D2AF61" }}
                      onClick={() => setChargeConfirmVisible(true)}
                      disabled={isCharging || remainingChargeAmount <= 0}
                    >
                      <span className="text-white fw-semibold">
                        {isCharging
                          ? "Charging..."
                          : remainingChargeAmount <= 0
                            ? "Fully charged separately"
                            : "Charge"}
                      </span>
                    </button>
                  </div>
                )}
            </div>
          )}

          <AddClientModal
            show={modalAddClientVisible}
            onClose={closeModalAddClient}
            onSuccessAddNewClient={onSuccessAddClient}
            onFailedAddNewClient={onFailedAddNewClient}
          />
          <EditClientModal
            show={modalEditClientVisible}
            client={fromBillingInformationForm.selectedClient}
            onClose={closeModalEditClient}
            onSuccessEditClient={onSuccessEditClient}
            onFailedEditClient={onFailedEditClient}
          />
          <ErrorModal
            show={errorModal}
            onClose={closeErrorModal}
            errorText={errorText}
          />
          <SubmitConfirmationModal
            show={modalSubmitConfirmation}
            onClose={closeModalSubmitConfirmation}
            onDiscard={handleDiscardEdit}
            onSaveAsDraft={() => handleActiveQuotation("DRAFT")}
            onSubmit={() => handleActiveQuotation("ACTIVE")}
            isEdit={quotationDetail?.quotationStatus === "ACTIVE"}
          />
          <AdminModal
            show={successModal.show}
            size="tw:!max-w-[600px]"
            centered={true}
            onClose={closeSuccessModal}
          >
            <div className="tw:flex tw:items-center tw:justify-center tw:gap-2">
              <img
                alt="success"
                src={check_green}
                width={18}
                height={18}
                className="flex-shrink-0"
              />
              <span className="tw:!text-[18px] tw:!font-[600] tw:!text-[#3CAEA3] tw:whitespace-nowrap">
                {successModal.message}
              </span>
            </div>
          </AdminModal>
          <DeleteTransferConfirmationModal
            show={modalDeleteTransferConfirmation}
            onClose={closeModalDeleteTransferConfirmation}
            onDelete={() => handleDeleteTransfer(quotationId, deleteTransferId)}
          />

          <TransferDetailModal
            show={modalDetailTransfer}
            onClose={closeModalDetailTransfer}
            detailTransfer={detailTransfer}
            quotationDetail={quotationDetail}
            onEdit={() => {
              closeModalDetailTransfer();
              handleNavigateToEditTransfer(detailTransfer);
            }}
            onDuplicate={() => {
              closeModalDetailTransfer();
              openModalDuplicate(detailTransfer._id);
            }}
            onDelete={() => {
              closeModalDetailTransfer();
              openModalDeleteTransferConfirmation(detailTransfer._id);
            }}
          />

          <ActivateQuotationModal
            show={activateModalVisible}
            quotationID={quotationDetail?.quotationID}
            issueDate={activateIssueDate}
            expiryDate={activateExpiryDate}
            onSelectIssueDate={(date) => {
              setActivateIssueDate(date);
              setActivateError("");
            }}
            onSelectExpiryDate={(date) => {
              setActivateExpiryDate(date);
              setActivateError("");
            }}
            onClose={closeActivateModal}
            onActivate={handleReactivateQuotation}
            isActivating={isActivating}
            error={activateError}
          />

          <ConfirmationModal
            show={expireModalVisible}
            title={`Deactivate quotation ${quotationDetail?.quotationID || ""}?`}
            description="The quotation is deactivated today and the customer can no longer pay through its link. You can reactivate it later with new dates."
            variant="danger"
            confirmLabel="Deactivate"
            busyLabel="Deactivating…"
            isBusy={isExpiring}
            error={expireError}
            onCancel={closeExpireModal}
            onConfirm={handleExpireQuotation}
          />

          <DuplicateTransferModal
            show={modalDuplicate}
            onClose={closeModalDuplicate}
            recurringTravelDates={recurringTravelDates}
            onSelectDate={handleSelectTravelDate}
            onAddDate={addReccuringTravelDate}
            onRemoveDate={removeReccuringTravelDate}
            loadingDuplicate={loadingDuplicate}
            onDuplicate={handleDuplicateTransfer}
          />
          <RemoveAllItemsConfirmationModal
            show={confirmRemoveAllVisible}
            onClose={() => setConfirmRemoveAllVisible(false)}
            onContinue={() => {
              removeAllItemsQuotation()
            }}
          />
          <RemoveAllItemsConfirmationModal
            show={confirmRemoveStandaloneVisible}
            onClose={() => setConfirmRemoveStandaloneVisible(false)}
            onContinue={() => removeAllStandaloneItems()}
          />

          <ConfirmationModal
            show={pendingBookingSortOrder !== null}
            title={`Order transfers by ${getBookingSortLabel(pendingBookingSortOrder)}?`}
            description="This order is saved and also shown to the client on their quotation page, download and PDF."
            confirmLabel="Save Order"
            busyLabel="Saving…"
            isBusy={isSavingSortOrder}
            error={sortOrderError}
            onCancel={closeSortOrderConfirmation}
            onConfirm={handleConfirmBookingSortOrder}
          />

          <ConfirmationModal
            show={chargeConfirmVisible}
            title={`Charge ${remainingChargeAmount.toLocaleString()} JPY for quotation ${quotationDetail?.quotationID || ""}?`}
            description="This action cannot be undone."
            variant="gold"
            confirmLabel="Confirm Charge"
            busyLabel="Charging…"
            isBusy={isCharging}
            onCancel={() => setChargeConfirmVisible(false)}
            onConfirm={handleChargeQuotation}
          >
            {separatelyChargedTotal > 0 && (
              <p className="tw:!text-center tw:!text-[14px] tw:!text-[#8D8D8D] tw:!mb-0">
                {`This is the quotation total of ${computedTotalAmount.toLocaleString()} JPY minus ${separatelyChargedTotal.toLocaleString()} JPY for `}
                {separatelyChargedBookings.length === 1 ? "a booking" : `${separatelyChargedBookings.length} bookings`}
                {" already charged separately."}
              </p>
            )}
          </ConfirmationModal>

        </main>
      </Layout>
    </>
  );
};

export default QuotationDetail;
